export const gameActivityLast30 = {
    "1774625766547-1772569886040-86781-LNymX-challenge-edited": {
    "id": "1774625766547-1772569886040-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
    "info": "",
    "ts": 1774625766547,
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Challenge Edited",
    "title": "Veni, Vidi, Vici has been edited.",
    "type": "editedChallenge",
    "path": "ibh66d4ei44mrpswmj",
    "display": "managerActivity"
  },
  "1774643897440-7ms5igiTjjh4cLmunxfSTJU9-level": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "ts": 1774643897440,
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "elementId": "1772590648474-86781-LNymX-level",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "event": "Level Earned",
    "id": "1774643897440-7ms5igiTjjh4cLmunxfSTJU9-level",
    "type": "levels",
    "path": "ewq98we-u3ccj8yjzp",
    "data": {
      "17746438974413s6pv-currency": {
        "quantity": 200,
        "title": "$200 Earned",
        "icon": "/images/icons/currency.png",
        "id": "currency",
        "type": "currency"
      }
    },
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "display": "achievement",
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned"
  },
  "1774663161106-ZCYz3Xwi3rCgnv6BMyZPV88E-level": {
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned",
    "type": "levels",
    "path": "6not4cno2483fmf0uc",
    "data": {
      "1774663161107ddphc-currency": {
        "quantity": 200,
        "title": "$200 Earned",
        "icon": "/images/icons/currency.png",
        "id": "currency",
        "type": "currency"
      }
    },
    "display": "achievement",
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "elementId": "1772590648474-86781-LNymX-level",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "id": "1774663161106-ZCYz3Xwi3rCgnv6BMyZPV88E-level",
    "event": "Level Earned",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "ts": 1774663161106,
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom."
  },
  "1774663185404-ZCYz3Xwi3rCgnv6BMyZPV88E-purchase": {
    "type": "purchase",
    "cartTotal": 200,
    "path": "a-hci3pg4_a5p64yqx",
    "data": {
      "1774663185406i6n8z-item": {
        "title": "Item Purchased: The Praetorian Pardon",
        "saleId": "",
        "cost": 200,
        "itemType": "inventory",
        "id": "1772230537885-86781-LNymX-item",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307966654-Inventory%20Item%20(5).png?alt=media&token=8b912143-3194-4e0d-a647-9a7e34c2949d",
        "purchase": true,
        "name": "The Praetorian Pardon",
        "quantity": 1,
        "type": "item"
      }
    },
    "display": "purchase",
    "rewardIds": [
      "currency",
      "1772230537885-86781-LNymX-item"
    ],
    "spec": 200,
    "userName": "Beatrice Knight",
    "activity": "Purchase Completed",
    "title": "Purchase Completed",
    "cartQuantity": 1,
    "icon": "/images/icons/shopping-cart.png",
    "info": "",
    "ts": 1774663185404,
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "id": "1774663185404-ZCYz3Xwi3rCgnv6BMyZPV88E-purchase",
    "event": "Purchase Completed",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774663210139-ZCYz3Xwi3rCgnv6BMyZPV88E-secretCode": {
    "display": "reward",
    "rewardIds": [
      "1772595348386-86781-LNymX-secretCode",
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "data": {
      "1774663210140w29fp-currency": {
        "quantity": 50,
        "icon": "/images/icons/currency.png",
        "title": "$50 Earned",
        "id": "currency",
        "type": "currency"
      },
      "177466321014125rps-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "cost": 500,
        "type": "prizepack",
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest"
      }
    },
    "path": "yvhun6hpzn4z5xr9x_",
    "type": "secretCode",
    "activity": "Secret Code Found",
    "comments": "",
    "title": "EPICUS-284",
    "ts": 1774663210139,
    "info": "Hidden in the guidance office",
    "icon": "/images/icons/secret.png",
    "event": "Secret Code Found",
    "id": "1774663210139-ZCYz3Xwi3rCgnv6BMyZPV88E-secretCode",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772595348386-86781-LNymX-secretCode"
  },
  "1774663210142-ZCYz3Xwi3rCgnv6BMyZPV88E-prizepack": {
    "activity": "New Prize Pack",
    "spec": "",
    "title": "The Tribute Chest",
    "display": "prizepack",
    "rewardIds": [
      "1772230537868-86781-LNymX-item",
      "1772230537866-86781-LNymX-item",
      "1772230537875-86781-LNymX-item"
    ],
    "data": {
      "1774663210145-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b",
        "title": "Item Earned: Scroll Fragment",
        "quantity": 1,
        "type": "items",
        "id": "1772230537875-86781-LNymX-item"
      },
      "1774663210144-items": {
        "id": "1772230537866-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "title": "Item Earned: Aureus Coin",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c"
      },
      "1774663210143-items": {
        "id": "1772230537868-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "title": "Item Earned: Fragment of a Roman Mosaic Tile",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad"
      }
    },
    "type": "rewards",
    "path": "2057qnr5et3ge38fv3",
    "id": "1774663210142-ZCYz3Xwi3rCgnv6BMyZPV88E-prizepack",
    "event": "Prize Pack Earned",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "info": "",
    "ts": 1774663210142,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8"
  },
  "1774792117506-1772230537880-86781-LNymX-item-edited": {
    "ts": 1774792117506,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306786854-Access%20Item%20(2).png?alt=media&token=d6bcc89e-6c1d-4a69-b47b-d57202dd2d1b",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792117506-1772230537880-86781-LNymX-item-edited",
    "display": "managerActivity",
    "path": "4gufihjzf-beokqwsz",
    "type": "editedItem",
    "title": "The Codex Aureus has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1774792166837-1772230537887-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "The Signet Ring (Seal of Authority) has been edited.",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "0qcew0zs5a99x6gi0n",
    "event": "Item Edited",
    "id": "1774792166837-1772230537887-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1774792166837,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306152881-Access%20Item%20(1).png?alt=media&token=9572a5ae-5f50-4478-9e76-0e5f361ddeea"
  },
  "1774792591338-1772230537866-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "type": "editedItem",
    "path": "4dpt0v53fhmgsr9-ho",
    "title": "Aureus Coin has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "ts": 1774792591338,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792591338-1772230537866-86781-LNymX-item-edited"
  },
  "1774792601716-1772230537868-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792601716-1772230537868-86781-LNymX-item-edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad",
    "ts": 1774792601716,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Fragment of a Roman Mosaic Tile has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "type": "editedItem",
    "path": "pse8z4ze48i7h0i6ck",
    "display": "managerActivity"
  },
  "1774792626478-1772230537888-86781-LNymX-item-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1774792626478,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
    "id": "1774792626478-1772230537888-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "pkf85-8_7uxijziuw5",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Jupiter's Thunderbolt has been edited."
  },
  "1774792645379-1772230537891-86781-LNymX-item-edited": {
    "type": "editedItem",
    "path": "hbpj5-mgo6u8daajd8",
    "display": "managerActivity",
    "title": "Mercury's Winged Sandal has been edited.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295414866-final-sandal.png?alt=media&token=72853a72-1622-45c1-aae9-f5d9dea654dc",
    "info": "",
    "ts": 1774792645379,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774792645379-1772230537891-86781-LNymX-item-edited",
    "event": "Item Edited"
  },
  "1774792657892-1772230537890-86781-LNymX-item-edited": {
    "ts": 1774792657892,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295099861-Inventory%20Item.png?alt=media&token=0d29ad82-fe6e-4e33-88ee-f8cf6a872b48",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792657892-1772230537890-86781-LNymX-item-edited",
    "display": "managerActivity",
    "path": "xp-b2mi-pqojuptt63",
    "type": "editedItem",
    "title": "Minerva's Owl has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774792681494-1772230537889-86781-LNymX-item-edited": {
    "event": "Item Edited",
    "id": "1774792681494-1772230537889-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295527734-Inventory%20Item.png?alt=media&token=84f0a9dc-39d9-492c-9bdf-4309442405ad",
    "info": "",
    "ts": 1774792681494,
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "title": "Neptune's Trident has been edited.",
    "path": "dfdyy8jsy5tvzfx20o",
    "type": "editedItem",
    "display": "managerActivity"
  },
  "1774792694642-1772230537875-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "2z8ukkunddiwran49c",
    "type": "editedItem",
    "title": "Scroll Fragment has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "info": "",
    "ts": 1774792694642,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792694642-1772230537875-86781-LNymX-item-edited"
  },
  "1774792744773-1772230537870-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792744773-1772230537870-86781-LNymX-item-edited",
    "info": "",
    "ts": 1774792744773,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Miniature Legionary Helmet has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "fjy75ndr0od4m4stcp"
  },
  "1774792969473-1772230537881-86781-LNymX-item-edited": {
    "title": "The Aegis of Aeneas has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "path": "99ghmhx6mbgcry9c47",
    "type": "editedItem",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792969473-1772230537881-86781-LNymX-item-edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303141509-Inventory%20Item%20(2).png?alt=media&token=4f138801-ddcf-4f5e-bd16-824a301c8b03",
    "ts": 1774792969473,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774792978326-1772230537883-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "vyhtwwa044vf_b0pmf",
    "type": "editedItem",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Apollo’s Laurel has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774792978326,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772300758021-Inventory%20Item%20(1).png?alt=media&token=5c8323e0-6e0c-4333-9aa5-05066cd46138",
    "event": "Item Edited",
    "id": "1774792978326-1772230537883-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774792993109-1772230537882-86781-LNymX-item-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774792993109,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303244750-Inventory%20Item%20(3).png?alt=media&token=8755aa8b-307b-4316-b462-ce838cacdaf5",
    "event": "Item Edited",
    "id": "1774792993109-1772230537882-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "path": "_jej6deee9ihicmpw_",
    "type": "editedItem",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "The Janus Key has been edited."
  },
  "1774793017047-1772230537884-86781-LNymX-item-edited": {
    "ts": 1774793017047,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307861026-Inventory%20Item%20(4).png?alt=media&token=990024c3-53a3-4d76-8eb0-12456828de8e",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774793017047-1772230537884-86781-LNymX-item-edited",
    "event": "Item Edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "n9-mcijxgq8d4-agwr",
    "title": "The Lyre of Orpheus has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774793031022-1772230537885-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "fp8pck5g0h9j69-o96",
    "type": "editedItem",
    "title": "The Praetorian Pardon has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "info": "",
    "ts": 1774793031022,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307966654-Inventory%20Item%20(5).png?alt=media&token=8b912143-3194-4e0d-a647-9a7e34c2949d",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793031022-1772230537885-86781-LNymX-item-edited"
  },
  "1774793041224-1772230537886-86781-LNymX-item-edited": {
    "info": "",
    "ts": 1774793041224,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772308091269-Inventory%20Item%20(6).png?alt=media&token=446851bc-81a0-4b02-9e75-d0fa1c7593ff",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793041224-1772230537886-86781-LNymX-item-edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "u-6s8t0tx3equsmjer",
    "title": "The Standard of the First Legion has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774793209337-1772230537869-86781-LNymX-item-edited": {
    "title": "Magister's Legatus (Teacher's Helper for a Day) has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "q2fta7kg0qe0myicx8",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793209337-1772230537869-86781-LNymX-item-edited",
    "ts": 1774793209337,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553695485-Inventory%20Item%20(7).png?alt=media&token=720d5f6e-2ad6-4c50-82b8-de7fe34d7874",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774793230918-1772230537871-86781-LNymX-item-edited": {
    "info": "",
    "ts": 1774793230918,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553717485-Inventory%20Item%20(8).png?alt=media&token=c931ffd9-c0a4-4569-b7ca-a34f8fc09913",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793230918-1772230537871-86781-LNymX-item-edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "3qathv59mdkrzpyhco",
    "title": "Otium Ludi (Free Time) has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774793258707-1772230537874-86781-LNymX-item-edited": {
    "event": "Item Edited",
    "id": "1774793258707-1772230537874-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554064109-Inventory%20Item%20(9).png?alt=media&token=24dc2242-4a6e-4408-92ab-e30dc774b072",
    "ts": 1774793258707,
    "info": "",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "Pilleus Libertatis (Hat Pass for a Day) has been edited.",
    "path": "ks-eav6-q2qv2aan2_",
    "type": "editedItem",
    "display": "managerActivity"
  },
  "1774793318209-1772230537879-86781-LNymX-item-edited": {
    "id": "1774793318209-1772230537879-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564972120-Inventory%20Item%20(13).png?alt=media&token=d82cc334-3bc9-49a7-a89d-13608f1b7dba",
    "info": "",
    "ts": 1774793318209,
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "title": "Abacus of the Architect has been edited.",
    "type": "editedItem",
    "path": "ejoipp6fpp6wymnn5f",
    "display": "managerActivity"
  },
  "1774793333472-1772230537876-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Sella Curulis (Special Chair for a Day) has been edited.",
    "display": "managerActivity",
    "path": "-ptkyfw9xyzkikodrj",
    "type": "editedItem",
    "event": "Item Edited",
    "id": "1774793333472-1772230537876-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774793333472,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554085909-Inventory%20Item%20(10).png?alt=media&token=4a453739-b714-480d-985a-84794eab7cdd"
  },
  "1774793344156-1772230537877-86781-LNymX-item-edited": {
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "Tabula Rasa (Homework Pass) has been edited.",
    "path": "qdfp744yjp7myk90sc",
    "type": "editedItem",
    "display": "managerActivity",
    "event": "Item Edited",
    "id": "1774793344156-1772230537877-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554116045-Inventory%20Item%20(11).png?alt=media&token=ba00b05b-5742-4579-84d0-25894c91a127",
    "ts": 1774793344156,
    "info": ""
  },
  "1774793356580-1772230537878-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "vzwru8ob0ajb5eny5w",
    "type": "editedItem",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Tempus Solutum (Free Time) has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774793356580,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564941724-Inventory%20Item%20(12).png?alt=media&token=19096192-f911-49e3-8280-c8c0e400e266",
    "event": "Item Edited",
    "id": "1774793356580-1772230537878-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774818340234-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge": {
    "appId": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
    "ts": 1774818340234,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "id": "1774818340234-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge",
    "event": "Challenge Submitted",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569886040-86781-LNymX-challenge",
    "path": "jcgeqtbs4q2xauacyr",
    "type": "actionItem",
    "rewardIds": [
      "1772569886040-86781-LNymX-challenge"
    ],
    "display": "playerActivity",
    "activity": "Challenge Submitted",
    "title": "Veni, Vidi, Vici"
  }
}

export const gameActivityComplete = {
  "1772202099979-playerlistupload-players": {
    "event": "Player List Uploaded",
    "id": "1772202099979-playerlistupload-players",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772202099979,
    "info": "",
    "icon": "/images/icons/new.png",
    "activity": "Player List Uploaded",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "25 players have been uploaded",
    "display": "managerActivity",
    "path": "g5ve56b0xyy_5t7qvv",
    "type": "players"
  },
  "1772230537866-uploadeditems-items": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "/images/icons/items.png",
    "info": "",
    "ts": 1772230537866,
    "id": "1772230537866-uploadeditems-items",
    "event": "Items Uploaded",
    "gameId": "1772165586781-LNymXRI-game",
    "type": "items",
    "path": "na7b880e-rcwa62j9p",
    "display": "managerActivity",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Items Uploaded",
    "title": "26 items have been uploaded"
  },
  "1772230595635-1772230537883-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230595635-1772230537883-86781-LNymX-item-edited",
    "event": "Item Edited",
    "info": "",
    "ts": 1772230595635,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772230591953-laurel.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Apollo’s Laurel has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "06ri8r2iik-4j7h6d-"
  },
  "1772233189515-1772233183963-86781-LNymX-collection-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Collection Created",
    "id": "1772233189515-1772233183963-86781-LNymX-collection-created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772233182186-Collectible.jpg",
    "ts": 1772233189515,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Pantheons Favor has been created.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Collection Created",
    "path": "622-nws6p8okxrz6_p",
    "type": "createdCollection",
    "display": "managerActivity"
  },
  "1772256405703-1772230537888-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Jupiter's Thunderbolt has been edited.",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "w8kghzg7bzvf3zt2_f",
    "id": "1772256405703-1772230537888-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772256405703,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772256398592-Untitled drawing (10).jpg"
  },
  "1772257081037-1772230537888-86781-LNymX-item-edited": {
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "Jupiter's Thunderbolt has been edited.",
    "type": "editedItem",
    "path": "wfyw9q4vhw6kv24zeo",
    "display": "managerActivity",
    "event": "Item Edited",
    "id": "1772257081037-1772230537888-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772257079260-Inventory Item.png",
    "ts": 1772257081037,
    "info": ""
  },
  "1772295101181-1772230537890-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772295101181-1772230537890-86781-LNymX-item-edited",
    "info": "",
    "ts": 1772295101181,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772295099861-Inventory Item.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Minerva's Owl has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "-of99c5un4xn2r7tq9"
  },
  "1772295259419-1772230537888-86781-LNymX-item-edited": {
    "info": "",
    "ts": 1772295259419,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772295258265-Inventory Item (1).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772295259419-1772230537888-86781-LNymX-item-edited",
    "event": "Item Edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "3jqbr75j64zb-gkgio",
    "title": "Jupiter's Thunderbolt has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1772295416236-1772230537891-86781-LNymX-item-edited": {
    "title": "Mercury's Winged Sandal has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "vswstnrsn0o2kwi-vr",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772295416236-1772230537891-86781-LNymX-item-edited",
    "event": "Item Edited",
    "info": "",
    "ts": 1772295416236,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772295414866-final-sandal.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772295529186-1772230537889-86781-LNymX-item-edited": {
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "title": "Neptune's Trident has been edited.",
    "type": "editedItem",
    "path": "i-3zitx-qfxcn94nqa",
    "display": "managerActivity",
    "id": "1772295529186-1772230537889-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772295527734-Inventory Item.png",
    "info": "",
    "ts": 1772295529186
  },
  "1772297994096-1772230537866-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "type": "editedItem",
    "path": "yb9bc_bccm0qw8se9e",
    "title": "Aureus Coin has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "info": "",
    "ts": 1772297994096,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772297989450-Collectible Item.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772297994096-1772230537866-86781-LNymX-item-edited",
    "event": "Item Edited"
  },
  "1772298425372-1772230537866-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "kxpy4yd2bjigg3jufw",
    "type": "editedItem",
    "title": "Aureus Coin has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "info": "",
    "ts": 1772298425372,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772298423461-Collectible Item (1).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772298425372-1772230537866-86781-LNymX-item-edited"
  },
  "1772298749928-1772230537868-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772298749928-1772230537868-86781-LNymX-item-edited",
    "event": "Item Edited",
    "info": "",
    "ts": 1772298749928,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772298748505-Collectible Item (2).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Fragment of a Roman Mosaic Tile has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "smy5_s2td23cds3o0i"
  },
  "1772298862949-1772230537870-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Miniature Legionary Helmet has been edited.",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "y8nk08t6qe9gtv6-o4",
    "event": "Item Edited",
    "id": "1772298862949-1772230537870-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772298862949,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772298861728-Collectible Item (3).png"
  },
  "1772299174398-1772230537875-86781-LNymX-item-edited": {
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "Scroll Fragment has been edited.",
    "type": "editedItem",
    "path": "rxy2vcqw2infos8urn",
    "display": "managerActivity",
    "id": "1772299174398-1772230537875-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772299172837-Collectible Item (4).png",
    "ts": 1772299174398,
    "info": ""
  },
  "1772300762556-1772230537883-86781-LNymX-item-edited": {
    "title": "Apollo’s Laurel has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "path": "wgnxkos3bhy3poakdf",
    "type": "editedItem",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772300762556-1772230537883-86781-LNymX-item-edited",
    "info": "",
    "ts": 1772300762556,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772300758021-Inventory Item (1).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772303146988-1772230537881-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772303146988-1772230537881-86781-LNymX-item-edited",
    "event": "Item Edited",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772303141509-Inventory Item (2).png",
    "ts": 1772303146988,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Aegis of Aeneas has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "type": "editedItem",
    "path": "danqrgdte0_s9nqe_3",
    "display": "managerActivity"
  },
  "1772303246035-1772230537882-86781-LNymX-item-edited": {
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "title": "The Janus Key has been edited.",
    "type": "editedItem",
    "path": "e7wii9a0y69fik2cqn",
    "display": "managerActivity",
    "event": "Item Edited",
    "id": "1772303246035-1772230537882-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772303244750-Inventory Item (3).png",
    "ts": 1772303246035,
    "info": ""
  },
  "1772304962706-1772230537887-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "The Signet Ring (Seal of Authority) has been edited.",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "uymys5_qnup_0b7ody",
    "id": "1772304962706-1772230537887-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772304962706,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772304958085-Access Item.png"
  },
  "1772306157807-1772230537887-86781-LNymX-item-edited": {
    "id": "1772306157807-1772230537887-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772306152881-Access Item (1).png",
    "info": "",
    "ts": 1772306157807,
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "The Signet Ring (Seal of Authority) has been edited.",
    "type": "editedItem",
    "path": "8p50z0f8g06wo-u4j_",
    "display": "managerActivity"
  },
  "1772306788933-1772230537880-86781-LNymX-item-edited": {
    "ts": 1772306788933,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772306786854-Access Item (2).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772306788933-1772230537880-86781-LNymX-item-edited",
    "display": "managerActivity",
    "path": "i3g65_hjmq3wq7a6iz",
    "type": "editedItem",
    "title": "The Codex Aureus has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1772307862508-1772230537884-86781-LNymX-item-edited": {
    "info": "",
    "ts": 1772307862508,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772307861026-Inventory Item (4).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772307862508-1772230537884-86781-LNymX-item-edited",
    "event": "Item Edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "4fjikdmea0esquur9b",
    "title": "The Lyre of Orpheus has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1772307967991-1772230537885-86781-LNymX-item-edited": {
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772307966654-Inventory Item (5).png",
    "ts": 1772307967991,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772307967991-1772230537885-86781-LNymX-item-edited",
    "path": "8yysz_yb554s6aokg4",
    "type": "editedItem",
    "display": "managerActivity",
    "title": "The Praetorian Pardon has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited"
  },
  "1772308092757-1772230537886-86781-LNymX-item-edited": {
    "ts": 1772308092757,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772308091269-Inventory Item (6).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772308092757-1772230537886-86781-LNymX-item-edited",
    "display": "managerActivity",
    "path": "acxsg0g0btjnjudxo4",
    "type": "editedItem",
    "title": "The Standard of the First Legion has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1772553697717-1772230537869-86781-LNymX-item-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772553695485-Inventory Item (7).png",
    "info": "",
    "ts": 1772553697717,
    "id": "1772553697717-1772230537869-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "type": "editedItem",
    "path": "xgzrnca47v7fxjrmq5",
    "display": "managerActivity",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "title": "Magister's Legatus (Teacher's Helper for a Day) has been edited."
  },
  "1772553719540-1772230537871-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "dtpk9x97mxz8_8d6kr",
    "type": "editedItem",
    "title": "Otium Ludi (Free Time) has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "info": "",
    "ts": 1772553719540,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772553717485-Inventory Item (8).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772553719540-1772230537871-86781-LNymX-item-edited"
  },
  "1772554066316-1772230537874-86781-LNymX-item-edited": {
    "title": "Pilleus Libertatis (Hat Pass for a Day) has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "23bm2pc-udvzczunjy",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772554066316-1772230537874-86781-LNymX-item-edited",
    "event": "Item Edited",
    "info": "",
    "ts": 1772554066316,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772554064109-Inventory Item (9).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772554088005-1772230537876-86781-LNymX-item-edited": {
    "title": "Sella Curulis (Special Chair for a Day) has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "type": "editedItem",
    "path": "yxa7trhjpffgnjj2-h",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772554088005-1772230537876-86781-LNymX-item-edited",
    "event": "Item Edited",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772554085909-Inventory Item (10).png",
    "info": "",
    "ts": 1772554088005,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772554118119-1772230537877-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772554118119-1772230537877-86781-LNymX-item-edited",
    "event": "Item Edited",
    "info": "",
    "ts": 1772554118119,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772554116045-Inventory Item (11).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Tabula Rasa (Homework Pass) has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "r6_zard_e6ro2sayea"
  },
  "1772563865650-1772563864434-86781-LNymX-item-created": {
    "type": "createdItem",
    "path": "jzc8st3qbk0txo7y80",
    "display": "managerActivity",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Created",
    "title": "One Snack Item has been created.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772563862737-Real World Item Template.png",
    "info": "",
    "ts": 1772563865650,
    "id": "1772563865650-1772563864434-86781-LNymX-item-created",
    "event": "Item Created",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772564142589-1772563864434-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772564142589-1772563864434-86781-LNymX-item-edited",
    "event": "Item Edited",
    "info": "",
    "ts": 1772564142589,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564140348-Real World Item Template (1).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "One Snack Item has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "ef29fryd5co6ntnskz"
  },
  "1772564323970-1772564322752-86781-LNymX-item-created": {
    "activity": "Item Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "One Soda has been created.",
    "display": "managerActivity",
    "path": "ndar0ew88unkj0wtww",
    "type": "createdItem",
    "event": "Item Created",
    "id": "1772564323970-1772564322752-86781-LNymX-item-created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772564323970,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564321316-Real World Item Template (2).png"
  },
  "1772564440390-1772230537872-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772564440390-1772230537872-86781-LNymX-item-edited",
    "event": "Item Edited",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564438056-Real World Item Template (3).png",
    "ts": 1772564440390,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Pencil has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "type": "editedItem",
    "path": "y__xv7n72oe2c9vrs0",
    "display": "managerActivity"
  },
  "1772564913664-1772230537873-86781-LNymX-item-edited": {
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564911284-Real World Item Template (4).png",
    "ts": 1772564913664,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772564913664-1772230537873-86781-LNymX-item-edited",
    "path": "w5nkdk7609a-fmvvyo",
    "type": "editedItem",
    "display": "managerActivity",
    "title": "Piece of Candy has been edited.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited"
  },
  "1772564943941-1772230537878-86781-LNymX-item-edited": {
    "title": "Tempus Solutum (Free Time) has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "fzvg-d4-io-m5x2nk0",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1772564943941-1772230537878-86781-LNymX-item-edited",
    "info": "",
    "ts": 1772564943941,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564941724-Inventory Item (12).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772564974434-1772230537879-86781-LNymX-item-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772564974434,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564972120-Inventory Item (13).png",
    "id": "1772564974434-1772230537879-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "dam3x35f9isdzaecax",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Roman Abacus has been edited."
  },
  "1772566159666-1772230537867-86781-LNymX-item-edited": {
    "type": "editedItem",
    "path": "4vuap4bvw_y8qpvq0q",
    "display": "managerActivity",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "Outside time for the Class has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772566157283-Contribution Item Template.png",
    "ts": 1772566159666,
    "info": "",
    "id": "1772566159666-1772230537867-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772566215848-1772230537867-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Forum Collection: Outside Time has been edited.",
    "display": "managerActivity",
    "path": "w28nnuk5r30ob_t_q-",
    "type": "editedItem",
    "event": "Item Edited",
    "id": "1772566215848-1772230537867-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772566215848,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772566213635-Contribution Item Template (1).png"
  },
  "1772566407437-1772566406210-86781-LNymX-item-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Created",
    "id": "1772566407437-1772566406210-86781-LNymX-item-created",
    "ts": 1772566407437,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772566404290-Contribution Item Template (2).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Forum Collection: Pizza Party has been created.",
    "activity": "Item Created",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "path": "97rkz3ytxdh4nk085f",
    "type": "createdItem"
  },
  "1772566551781-1772230537872-86781-LNymX-item-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772566551781,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564438056-Real World Item Template (3).png",
    "event": "Item Edited",
    "id": "1772566551781-1772230537872-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "os_w93eyyobnai6neb",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "One Pencil has been edited."
  },
  "1772566562625-1772230537873-86781-LNymX-item-edited": {
    "id": "1772566562625-1772230537873-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772564911284-Real World Item Template (4).png",
    "info": "",
    "ts": 1772566562625,
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "One Piece of Candy has been edited.",
    "type": "editedItem",
    "path": "tv4odd_s6d3-y5prku",
    "display": "managerActivity"
  },
  "1772566828397-1772566827182-86781-LNymX-item-created": {
    "info": "",
    "ts": 1772566828397,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772566825895-Real World Item Template (5).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772566828397-1772566827182-86781-LNymX-item-created",
    "event": "Item Created",
    "display": "managerActivity",
    "type": "createdItem",
    "path": "x7sdzwe4tr4tn67_vf",
    "title": "One Mechanical Pencil has been created.",
    "activity": "Item Created",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1772567716915-1772567715658-86781-LNymX-badge-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772567716915-1772567715658-86781-LNymX-badge-created",
    "event": "Badge Created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772567714277-Badge Template.png",
    "ts": 1772567716915,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Eloquentia (The Gift of Eloquence) has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Badge Created",
    "type": "createdBadge",
    "path": "ig97zm20h-q0gfv4co",
    "display": "managerActivity"
  },
  "1772568084808-1772568083563-86781-LNymX-badge-created": {
    "title": "Nocturnal Scholar (Reading for Pleasure) has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Badge Created",
    "type": "createdBadge",
    "path": "w3esy9i3vypegn2hxq",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Badge Created",
    "id": "1772568084808-1772568083563-86781-LNymX-badge-created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772568081970-Badge Template (1).png",
    "ts": 1772568084808,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772568316285-1772568315017-86781-LNymX-badge-created": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772568316285,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772568313294-Badge Template (2).png",
    "event": "Badge Created",
    "id": "1772568316285-1772568315017-86781-LNymX-badge-created",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "path": "8xdt0hw4h7ft7um8pq",
    "type": "createdBadge",
    "activity": "Badge Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "The Archivists Triumph (Achievement in Organization) has been created."
  },
  "1772568429485-1772568315017-86781-LNymX-badge-edited": {
    "id": "1772568429485-1772568315017-86781-LNymX-badge-edited",
    "event": "Badge Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772568313294-Badge Template (2).png",
    "info": "",
    "ts": 1772568429485,
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Badge Edited",
    "title": "The Archivists Triumph (Achievement in Organization) has been edited.",
    "type": "editedBadge",
    "path": "y8icf5xm-zxcdxtcri",
    "display": "managerActivity"
  },
  "1772568445461-1772568083563-86781-LNymX-badge-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Badge Edited",
    "id": "1772568445461-1772568083563-86781-LNymX-badge-edited",
    "ts": 1772568445461,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772568081970-Badge Template (1).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Nocturnal Scholar (Reading for Pleasure) has been edited.",
    "activity": "Badge Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "path": "8-hvozgpys52n5wp_0",
    "type": "editedBadge"
  },
  "1772568474544-1772567715658-86781-LNymX-badge-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Badge Edited",
    "id": "1772568474544-1772567715658-86781-LNymX-badge-edited",
    "ts": 1772568474544,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772567714277-Badge Template.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Eloquentia (The Gift of Eloquence) has been edited.",
    "activity": "Badge Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedBadge",
    "path": "aud_ov0w_376q_uzqj"
  },
  "1772568609248-1772568608019-86781-LNymX-badge-created": {
    "title": "Grammaticus Maximus (Achievement in Writing) has been created.",
    "activity": "Badge Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "createdBadge",
    "path": "y4sxabz_92vfo9gn9c",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772568609248-1772568608019-86781-LNymX-badge-created",
    "event": "Badge Created",
    "info": "",
    "ts": 1772568609248,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772568606661-Badge Template (3).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772568759853-1772568758645-86781-LNymX-badge-created": {
    "activity": "Badge Created",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Rhetorics Aegis (Arguments with Aplomb) has been created.",
    "display": "managerActivity",
    "path": "g90xrxupsowcxu__uz",
    "type": "createdBadge",
    "event": "Badge Created",
    "id": "1772568759853-1772568758645-86781-LNymX-badge-created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772568759853,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772568757154-Badge Template (5).png"
  },
  "1772568922858-1772568921625-86781-LNymX-badge-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772568922858-1772568921625-86781-LNymX-badge-created",
    "event": "Badge Created",
    "info": "",
    "ts": 1772568922858,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772568919961-Badge Template (6).png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Scribe Velocity (Speed of Script) has been created.",
    "activity": "Badge Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "createdBadge",
    "path": "7uz264tir8idhnt2tj"
  },
  "1772569137960-1772569136690-86781-LNymX-badge-created": {
    "title": "Cursus Honorum (The Path of Honor) has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Badge Created",
    "path": "p-oidoa-0nuxy4c49r",
    "type": "createdBadge",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Badge Created",
    "id": "1772569137960-1772569136690-86781-LNymX-badge-created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772569134967-Badge Template (7).png",
    "ts": 1772569137960,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772569258766-1772569257452-86781-LNymX-badge-created": {
    "title": "Lexicon Legatus (Vocabulary Envoy) has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Badge Created",
    "path": "ud67n2gzns5r3en-5r",
    "type": "createdBadge",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Badge Created",
    "id": "1772569258766-1772569257452-86781-LNymX-badge-created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772569255869-Badge Template (8).png",
    "ts": 1772569258766,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772569771842-1772569770551-86781-LNymX-challenge-created": {
    "activity": "Challenge Created",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "The Forum Oration has been created.",
    "display": "managerActivity",
    "path": "ur598d_fqf0o3gg59k",
    "type": "createdChallenge",
    "event": "Challenge Created",
    "id": "1772569771842-1772569770551-86781-LNymX-challenge-created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772569771842,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772569769262-forum.png"
  },
  "1772569836157-1772569834612-86781-LNymX-challenge-created": {
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772569833138-prophecy.png",
    "info": "",
    "ts": 1772569836157,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772569836157-1772569834612-86781-LNymX-challenge-created",
    "event": "Challenge Created",
    "type": "createdChallenge",
    "path": "wj6uo8y-_teu5gt64h",
    "display": "managerActivity",
    "title": "The Sibylline Prophecy has been created.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Challenge Created"
  },
  "1772569887204-1772569886040-86781-LNymX-challenge-created": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772569884817-veni.png",
    "info": "",
    "ts": 1772569887204,
    "event": "Challenge Created",
    "id": "1772569887204-1772569886040-86781-LNymX-challenge-created",
    "gameId": "1772165586781-LNymXRI-game",
    "type": "createdChallenge",
    "path": "qp5x6niyr90e7-mnqj",
    "display": "managerActivity",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Challenge Created",
    "title": "Veni, Vidi, Vici has been created."
  },
  "1772569900253-1772569770551-86781-LNymX-challenge-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772569900253,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772569769262-forum.png",
    "event": "Challenge Edited",
    "id": "1772569900253-1772569770551-86781-LNymX-challenge-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "path": "p9ns49jhqqp5_89pm8",
    "type": "editedChallenge",
    "activity": "Challenge Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "The Forum Oration has been edited."
  },
  "1772569916005-1772569834612-86781-LNymX-challenge-edited": {
    "display": "managerActivity",
    "type": "editedChallenge",
    "path": "yvf08st72fi383biwn",
    "title": "The Sibylline Prophecy has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "info": "",
    "ts": 1772569916005,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772569833138-prophecy.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772569916005-1772569834612-86781-LNymX-challenge-edited",
    "event": "Challenge Edited"
  },
  "1772571727071-1772571725728-86781-LNymX-challenge-created": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772571727071,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772571724680-appian.png",
    "id": "1772571727071-1772571725728-86781-LNymX-challenge-created",
    "event": "Challenge Created",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "type": "createdChallenge",
    "path": "jdgckqra5dqx8e883h",
    "activity": "Challenge Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "The Appian Way has been created."
  },
  "1772571791095-1772571789776-86781-LNymX-challenge-created": {
    "event": "Challenge Created",
    "id": "1772571791095-1772571789776-86781-LNymX-challenge-created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772571791095,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772571788594-amphitheater.png",
    "activity": "Challenge Created",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Amphitheater Critique has been created.",
    "display": "managerActivity",
    "path": "97e2dcarphdj2-wm50",
    "type": "createdChallenge"
  },
  "1772571900294-1772571898963-86781-LNymX-challenge-created": {
    "path": "g2qnp243ddww2xte93",
    "type": "createdChallenge",
    "display": "managerActivity",
    "title": "Scriptorium Scroll has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Challenge Created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772571897664-scroll.png",
    "info": "",
    "ts": 1772571900294,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Created",
    "id": "1772571900294-1772571898963-86781-LNymX-challenge-created"
  },
  "1772572069891-1772572068570-86781-LNymX-challenge-created": {
    "title": "The Oracle's Verse has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Challenge Created",
    "type": "createdChallenge",
    "path": "xggv6z_3fw7bh3hxy0",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Created",
    "id": "1772572069891-1772572068570-86781-LNymX-challenge-created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772572067641-oracle2.png",
    "ts": 1772572069891,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772572119848-1772572118651-86781-LNymX-challenge-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Created",
    "id": "1772572119848-1772572118651-86781-LNymX-challenge-created",
    "ts": 1772572119848,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772572117328-journey.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Architects Blueprint has been created.",
    "activity": "Challenge Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "path": "ve9-fhuaacisu-g_z3",
    "type": "createdChallenge"
  },
  "1772572159170-1772572157879-86781-LNymX-challenge-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772572159170-1772572157879-86781-LNymX-challenge-created",
    "event": "Challenge Created",
    "info": "",
    "ts": 1772572159170,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772572156886-music.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Muses Soundtrack has been created.",
    "activity": "Challenge Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "createdChallenge",
    "path": "yhbdi_7bh_kcr5rjmn"
  },
  "1772572214154-1772572212961-86781-LNymX-challenge-created": {
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Challenge Created",
    "title": "The Scribes Illuminations has been created.",
    "type": "createdChallenge",
    "path": "pw7dxfsx_9ft6-_voy",
    "display": "managerActivity",
    "event": "Challenge Created",
    "id": "1772572214154-1772572212961-86781-LNymX-challenge-created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772572211824-sculptor.png",
    "info": "",
    "ts": 1772572214154
  },
  "1772590438600-1772590433659-86781-LNymX-collection-created": {
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772590432691-Collection Template.png",
    "ts": 1772590438600,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Collection Created",
    "id": "1772590438600-1772590433659-86781-LNymX-collection-created",
    "path": "bfy4fthm4kxkzxwc83",
    "type": "createdCollection",
    "display": "managerActivity",
    "title": "Relics of the Empire has been created.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Collection Created"
  },
  "1772590464005-1772233183963-86781-LNymX-collection-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772590464005-1772233183963-86781-LNymX-collection-edited",
    "event": "Collection Edited",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772233182186-Collectible.jpg",
    "info": "",
    "ts": 1772590464005,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Pantheons Favor has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Collection Edited",
    "type": "editedCollection",
    "path": "a78sj9zqc_7h_0jdy9",
    "display": "managerActivity"
  },
  "1772590650338-1772590648474-86781-LNymX-level-created": {
    "id": "1772590650338-1772590648474-86781-LNymX-level-created",
    "event": "Level Created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772590647276-tiro.png",
    "info": "",
    "ts": 1772590650338,
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Level Created",
    "title": "Tiro (The Recruit) has been created.",
    "type": "createdLevel",
    "path": "yaj0-mw783fk4j8r6v",
    "display": "managerActivity"
  },
  "1772590713628-1772590711756-86781-LNymX-level-created": {
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Level Created",
    "title": "Civis (The Citizen): has been created.",
    "type": "createdLevel",
    "path": "m-ah58igngyungi3y7",
    "display": "managerActivity",
    "id": "1772590713628-1772590711756-86781-LNymX-level-created",
    "event": "Level Created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772590710488-civis.png",
    "info": "",
    "ts": 1772590713628
  },
  "1772590723753-1772590711756-86781-LNymX-level-edited": {
    "title": "Civis (The Citizen): has been edited.",
    "activity": "Level Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "path": "0zg3uji4j7bxpejb7u",
    "type": "editedLevel",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Level Edited",
    "id": "1772590723753-1772590711756-86781-LNymX-level-edited",
    "ts": 1772590723753,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772590710488-civis.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772590999403-1772590997526-86781-LNymX-prizepack-created": {
    "path": "8r302fby95ye3h_g0i",
    "type": "createdItem",
    "display": "managerActivity",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Created",
    "title": "The Tribute Chest has been created.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772590995761-chest.png",
    "ts": 1772590999403,
    "info": "",
    "event": "Item Created",
    "id": "1772590999403-1772590997526-86781-LNymX-prizepack-created",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772591053053-1772590711756-86781-LNymX-level-edited": {
    "title": "Civis (The Citizen): has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Level Edited",
    "path": "6-8amwktmm0x7fa2jp",
    "type": "editedLevel",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Level Edited",
    "id": "1772591053053-1772590711756-86781-LNymX-level-edited",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772590710488-civis.png",
    "ts": 1772591053053,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772591113605-1772591111727-86781-LNymX-level-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Level Created",
    "id": "1772591113605-1772591111727-86781-LNymX-level-created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772591110285-centurion.png",
    "ts": 1772591113605,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Centurion (The Leader): has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Level Created",
    "path": "y-kisb_w_c05db8ha3",
    "type": "createdLevel",
    "display": "managerActivity"
  },
  "1772591194869-1772591192992-86781-LNymX-level-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772591194869-1772591192992-86781-LNymX-level-created",
    "event": "Level Created",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772591192026-statesman.png",
    "info": "",
    "ts": 1772591194869,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Senator (The Statesman): has been created.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Level Created",
    "type": "createdLevel",
    "path": "bvpb5ub2jx23f_w8q_",
    "display": "managerActivity"
  },
  "1772591249244-1772591247490-86781-LNymX-level-created": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772591249244,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772591246478-commander.png",
    "event": "Level Created",
    "id": "1772591249244-1772591247490-86781-LNymX-level-created",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "type": "createdLevel",
    "path": "wgz80nwsbeid_yv7sr",
    "activity": "Level Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Imperator (The Commander): has been created."
  },
  "1772595374684-uploadedcodes-secretcodes": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772595374684,
    "info": "",
    "icon": "/images/icons/secret.png",
    "event": "Secret Codes Uploaded",
    "id": "1772595374684-uploadedcodes-secretcodes",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "path": "4meagi35ceezhhprj0",
    "type": "secretCodes",
    "activity": "Secret Codes Uploaded",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "6 secret codes have been uploaded"
  },
  "1772597812599-1772590648474-86781-LNymX-level-edited": {
    "title": "Tiro (The Recruit) has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Level Edited",
    "type": "editedLevel",
    "path": "sj2zb-vwodg9aaez_h",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Level Edited",
    "id": "1772597812599-1772590648474-86781-LNymX-level-edited",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772597809330-tiro.png",
    "info": "",
    "ts": 1772597812599,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772597831490-1772590711756-86781-LNymX-level-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772597831490,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772597828647-civis.png",
    "id": "1772597831490-1772590711756-86781-LNymX-level-edited",
    "event": "Level Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "type": "editedLevel",
    "path": "j9xgzbjws_i76sb3uw",
    "activity": "Level Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Civis (The Citizen): has been edited."
  },
  "1772597845143-1772591111727-86781-LNymX-level-edited": {
    "display": "managerActivity",
    "path": "a0xrd0s4yefg63g4bv",
    "type": "editedLevel",
    "activity": "Level Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Centurion (The Leader): has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1772597845143,
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772597842378-centurion.png",
    "event": "Level Edited",
    "id": "1772597845143-1772591111727-86781-LNymX-level-edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772597860074-1772591192992-86781-LNymX-level-edited": {
    "display": "managerActivity",
    "type": "editedLevel",
    "path": "8iaijt_mxixyi2_2zx",
    "title": "Senator (The Statesman): has been edited.",
    "activity": "Level Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "ts": 1772597860074,
    "info": "",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772597857170-statesman.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Level Edited",
    "id": "1772597860074-1772591192992-86781-LNymX-level-edited"
  },
  "1772597876063-1772591247490-86781-LNymX-level-edited": {
    "event": "Level Edited",
    "id": "1772597876063-1772591247490-86781-LNymX-level-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "storage:LNymXRIM2ASSsSrLza6lfvWLXKz2/1772597873344-commander.png",
    "ts": 1772597876063,
    "info": "",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Level Edited",
    "title": "Imperator (The Commander): has been edited.",
    "type": "editedLevel",
    "path": "e3rwijcuoiqbt3wadi",
    "display": "managerActivity"
  },
  "1772686800409-teamSaved-players": {
    "display": "managerActivity",
    "type": "teams",
    "path": "dcfdzc_rvo6zq0ds_0",
    "title": "The Iron Legion Team has been created",
    "activity": "Team Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "info": "",
    "ts": 1772686800409,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772686800409-teamSaved-players",
    "event": "Team Created"
  },
  "1772687199072-teamSaved-players": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772687199072-teamSaved-players",
    "event": "Team Created",
    "ts": 1772687199072,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772687197598-Gemini_Generated_Image_mko59pmko59pmko5.jpg?alt=media&token=abb6c0e9-b303-4651-930f-3ffd96b834b0",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Gilded Senate Team has been created",
    "activity": "Team Created",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "path": "raixo2n3vy_krrz659",
    "type": "teams"
  },
  "1772689893425-teamSaved-players": {
    "display": "managerActivity",
    "type": "teams",
    "path": "ei0fcstmvu-p5zavcm",
    "title": "The Oracle Guard Team has been created",
    "activity": "Team Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "ts": 1772689893425,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772689891357-oracle-guard.jpg?alt=media&token=81e97221-80a0-4e2c-a355-33c134f2749c",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772689893425-teamSaved-players",
    "event": "Team Created"
  },
  "1772691605228-1772691604870-86781-LNymX-leaderboard-created": {
    "title": "Team Points has been created.",
    "activity": "Leaderboard Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "path": "4nvvnc488490ocq80f",
    "type": "createdLeaderboard",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Leaderboard Created",
    "id": "1772691605228-1772691604870-86781-LNymX-leaderboard-created",
    "ts": 1772691605228,
    "info": "",
    "icon": "/images/icons/leaderboard.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772691651616-1772691651374-86781-LNymX-leaderboard-created": {
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Leaderboard Created",
    "title": "Individual Leaders has been created.",
    "type": "createdLeaderboard",
    "path": "u0okga04kojqkqhxhm",
    "display": "managerActivity",
    "event": "Leaderboard Created",
    "id": "1772691651616-1772691651374-86781-LNymX-leaderboard-created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "/images/icons/leaderboard.png",
    "ts": 1772691651616,
    "info": ""
  },
  "1772691855258-1772691651374-86781-LNymX-leaderboard-edited": {
    "icon": "/images/icons/leaderboard.png",
    "info": "",
    "ts": 1772691855258,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772691855258-1772691651374-86781-LNymX-leaderboard-edited",
    "event": "Leaderboard Edited",
    "type": "editedLeaderboard",
    "path": "qm_-hfd23osin0m7tf",
    "display": "managerActivity",
    "title": "Individual XP Leaders has been edited.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Leaderboard Edited"
  },
  "1772691991537-1772691991174-86781-LNymX-leaderboard-created": {
    "activity": "Leaderboard Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Individual Currency Leaders has been created.",
    "display": "managerActivity",
    "path": "6-sfiukc3buf48mniw",
    "type": "createdLeaderboard",
    "event": "Leaderboard Created",
    "id": "1772691991537-1772691991174-86781-LNymX-leaderboard-created",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772691991537,
    "info": "",
    "icon": "/images/icons/leaderboard.png"
  },
  "1772981266524-GuYrAf2A7ofKh6Kim4OGv2ur-level": {
    "activity": "Level Earned",
    "title": "Tiro (The Recruit)",
    "type": "levels",
    "path": "jh8wuu9wwknfiqk2ut",
    "data": {
      "17729812665257n45g-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 200,
        "icon": "/images/icons/currency.png",
        "title": "$200 Earned"
      }
    },
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "display": "achievement",
    "playerId": "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
    "id": "1772981266524-GuYrAf2A7ofKh6Kim4OGv2ur-level",
    "event": "Level Earned",
    "elementId": "1772590648474-86781-LNymX-level",
    "gameId": "1772165586781-LNymXRI-game",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "ts": 1772981266524
  },
  "1773002231867-teamSaved-players": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Team Edited",
    "id": "1773002231867-teamSaved-players",
    "ts": 1773002231867,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Iron Legion Team has been edited",
    "activity": "Team Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "path": "pp0zi4ttt37o3ygrjo",
    "type": "teams"
  },
  "1773002268835-teamSaved-players": {
    "activity": "Team Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "The Iron Legion Team has been edited",
    "display": "managerActivity",
    "type": "teams",
    "path": "8ju93rbfpn36st0ceq",
    "id": "1773002268835-teamSaved-players",
    "event": "Team Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1773002268835,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9"
  },
  "1773002333791-teamSaved-players": {
    "ts": 1773002333791,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772689891357-oracle-guard.jpg?alt=media&token=81e97221-80a0-4e2c-a355-33c134f2749c",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Team Edited",
    "id": "1773002333791-teamSaved-players",
    "display": "managerActivity",
    "path": "jmg4-ggu92uupgva4_",
    "type": "teams",
    "title": "The Oracle Guard Team has been edited",
    "activity": "Team Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1773002386362-teamSaved-players": {
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Team Edited",
    "title": "The Iron Legion Team has been edited",
    "type": "teams",
    "path": "csn3xwv8su_5ayamvj",
    "display": "managerActivity",
    "event": "Team Edited",
    "id": "1773002386362-teamSaved-players",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "info": "",
    "ts": 1773002386362
  },
  "1773002413898-teamSaved-players": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772689891357-oracle-guard.jpg?alt=media&token=81e97221-80a0-4e2c-a355-33c134f2749c",
    "info": "",
    "ts": 1773002413898,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1773002413898-teamSaved-players",
    "event": "Team Edited",
    "type": "teams",
    "path": "3kcxu5qo46atbm50pq",
    "display": "managerActivity",
    "title": "The Oracle Guard Team has been edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Team Edited"
  },
  "1773006986422-teamSaved-players": {
    "event": "Team Edited",
    "id": "1773006986422-teamSaved-players",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "info": "",
    "ts": 1773006986422,
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Team Edited",
    "title": "The Iron Legion Team has been edited",
    "path": "vbs4-62t4doawcwmr0",
    "type": "teams",
    "display": "managerActivity"
  },
  "1773106687913-1773106682903-86781-LNymX-item-created": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Created",
    "id": "1773106687913-1773106682903-86781-LNymX-item-created",
    "ts": 1773106687913,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1773106680758-Lottery%20(1).png?alt=media&token=2f45d15d-ec16-4e26-a83e-3738bda533f1",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Pax Romana Lottery has been created.",
    "activity": "Item Created",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "createdItem",
    "path": "9enejr9um380p5mczx"
  },
  "1773161482264-43jfbVFSXCVW0uMFZk209aXq-level": {
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned",
    "display": "achievement",
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "data": {
      "1773161482265en2wt-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 200,
        "icon": "/images/icons/currency.png",
        "title": "$200 Earned"
      }
    },
    "path": "36mc-rpw59sfxgka4n",
    "type": "levels",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590648474-86781-LNymX-level",
    "event": "Level Earned",
    "id": "1773161482264-43jfbVFSXCVW0uMFZk209aXq-level",
    "playerId": "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "ts": 1773161482264,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6"
  },
  "1773199749239-1772569770551-86781-LNymX-challenge-edited": {
    "type": "editedChallenge",
    "path": "37uey0p649k56t6ii5",
    "display": "managerActivity",
    "title": "The Forum Oration has been edited.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Challenge Edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "ts": 1773199749239,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Edited",
    "id": "1773199749239-1772569770551-86781-LNymX-challenge-edited"
  },
  "1773200291375-1772569834612-86781-LNymX-challenge-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1773200291375-1772569834612-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "info": "",
    "ts": 1773200291375,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Sibylline Prophecy has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Challenge Edited",
    "type": "editedChallenge",
    "path": "c0_i3kn2f38ew7zb9d",
    "display": "managerActivity"
  },
  "1774495493475-dorHnQBtZQdnQ2brude9SEdJ-rewards": {
    "title": "Grammar Guardian Reward",
    "spec": "",
    "activity": "Rewards Earned",
    "type": "rewards",
    "path": "m86rdo5ntd6s6cjak7",
    "rewardIds": [
      "xp",
      "currency"
    ],
    "display": "reward",
    "data": {
      "17744954934787cpof-currency": {
        "type": "currency",
        "id": "currency",
        "title": "$100 Earned",
        "icon": "/images/icons/currency.png",
        "quantity": 100
      },
      "1774495493477vhztt-points": {
        "type": "xp",
        "id": "xp",
        "title": "20 XP Earned",
        "icon": "/images/xp.png",
        "quantity": 20
      }
    },
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
    "event": "Rewards Earned",
    "id": "1774495493475-dorHnQBtZQdnQ2brude9SEdJ-rewards",
    "icon": "/images/icons/treasure.png",
    "ts": 1774495493475,
    "info": "You caught a legitimate grammatical error in my slide deck!",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774495493476-axOQve3xXxzhqJ7OPczuoZFm-rewards": {
    "type": "rewards",
    "path": "-g4c9-756eojxrzg83",
    "data": {
      "1774495493479t22ek-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 100,
        "title": "$100 Earned",
        "icon": "/images/icons/currency.png"
      },
      "1774495493478tv5gd-points": {
        "id": "xp",
        "type": "xp",
        "quantity": 20,
        "title": "20 XP Earned",
        "icon": "/images/xp.png"
      }
    },
    "display": "reward",
    "rewardIds": [
      "xp",
      "currency"
    ],
    "spec": "",
    "activity": "Rewards Earned",
    "title": "Grammar Guardian Reward",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "/images/icons/treasure.png",
    "info": "You caught a legitimate grammatical error in my slide deck!",
    "ts": 1774495493476,
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "id": "1774495493476-axOQve3xXxzhqJ7OPczuoZFm-rewards",
    "event": "Rewards Earned",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774495493477-7ms5igiTjjh4cLmunxfSTJU9-rewards": {
    "id": "1774495493477-7ms5igiTjjh4cLmunxfSTJU9-rewards",
    "event": "Rewards Earned",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "You caught a legitimate grammatical error in my slide deck!",
    "ts": 1774495493477,
    "icon": "/images/icons/treasure.png",
    "activity": "Rewards Earned",
    "spec": "",
    "title": "Grammar Guardian Reward",
    "data": {
      "1774495493480rbxyf-currency": {
        "type": "currency",
        "id": "currency",
        "title": "$100 Earned",
        "icon": "/images/icons/currency.png",
        "quantity": 100
      },
      "1774495493479mfjjx-points": {
        "title": "20 XP Earned",
        "icon": "/images/xp.png",
        "quantity": 20,
        "type": "xp",
        "id": "xp"
      }
    },
    "display": "reward",
    "rewardIds": [
      "xp",
      "currency"
    ],
    "type": "rewards",
    "path": "bsqta45w3cacheq--6"
  },
  "1774495493478-w77EzNVefc5J22ZSzabDvbQr-rewards": {
    "activity": "Rewards Earned",
    "spec": "",
    "title": "Grammar Guardian Reward",
    "data": {
      "17744954934814kvgr-currency": {
        "type": "currency",
        "id": "currency",
        "icon": "/images/icons/currency.png",
        "title": "$100 Earned",
        "quantity": 100
      },
      "1774495493480a733f-points": {
        "type": "xp",
        "id": "xp",
        "icon": "/images/xp.png",
        "title": "20 XP Earned",
        "quantity": 20
      }
    },
    "rewardIds": [
      "xp",
      "currency"
    ],
    "display": "reward",
    "type": "rewards",
    "path": "bdzzi4a97hxp79p8p5",
    "event": "Rewards Earned",
    "id": "1774495493478-w77EzNVefc5J22ZSzabDvbQr-rewards",
    "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774495493478,
    "info": "You caught a legitimate grammatical error in my slide deck!",
    "icon": "/images/icons/treasure.png"
  },
  "1774495493480-LNymXRIM2ASSsSrLza6lfvWLXKz2-bulkDist": {
    "event": "Bulk Distribution",
    "id": "1774495493480-LNymXRIM2ASSsSrLza6lfvWLXKz2-bulkDist",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "/images/icons/treasure.png",
    "info": "You caught a legitimate grammatical error in my slide deck!",
    "ts": 1774495493480,
    "spec": "",
    "activity": "Bulk Distribution",
    "title": "Grammar Guardian Reward",
    "path": "n4ig75207b68vdhr_t",
    "type": "activityLog",
    "display": "managerActivity",
    "data": {
      "logs": [
        {
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
          "message": "Points awarded: 20",
          "playerName": "Aris, Felix"
        },
        {
          "message": "Currency awarded: 100",
          "playerName": "Aris, Felix",
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ"
        },
        {
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
          "message": "Points awarded: 20",
          "playerName": "Cross, Xavier"
        },
        {
          "message": "Currency awarded: 100",
          "playerName": "Cross, Xavier",
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm"
        },
        {
          "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
          "status": "success",
          "playerName": "Hugo, Victor",
          "message": "Points awarded: 20"
        },
        {
          "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
          "status": "success",
          "playerName": "Hugo, Victor",
          "message": "Currency awarded: 100"
        },
        {
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
          "message": "Points awarded: 20",
          "playerName": "Solis, Nadia"
        },
        {
          "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
          "status": "success",
          "playerName": "Solis, Nadia",
          "message": "Currency awarded: 100"
        }
      ]
    }
  },
  "1774497543502-OKBBAo2RM44OS9DjaPrHxwrU-level": {
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned",
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "display": "achievement",
    "data": {
      "1774497543503ujq79-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 200,
        "title": "$200 Earned",
        "icon": "/images/icons/currency.png"
      }
    },
    "type": "levels",
    "path": "oi23rd5u5orsqpwsnk",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590648474-86781-LNymX-level",
    "id": "1774497543502-OKBBAo2RM44OS9DjaPrHxwrU-level",
    "event": "Level Earned",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "ts": 1774497543502,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6"
  },
  "1774497583571-OKBBAo2RM44OS9DjaPrHxwrU-secretCode": {
    "activity": "Secret Code Found",
    "comments": "",
    "title": "PAPYRUS-893",
    "display": "reward",
    "rewardIds": [
      "1772595348383-86781-LNymX-secretCode",
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "data": {
      "1774497583572xokzs-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 50,
        "icon": "/images/icons/currency.png",
        "title": "$50 Earned"
      },
      "1774497583573vrmgd-prizepack": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest",
        "quantity": 1,
        "cost": 500,
        "type": "prizepack",
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "path": "i2j8w0-07h495x2jme",
    "type": "secretCode",
    "event": "Secret Code Found",
    "id": "1774497583571-OKBBAo2RM44OS9DjaPrHxwrU-secretCode",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772595348383-86781-LNymX-secretCode",
    "ts": 1774497583571,
    "info": "Hidden under a chair in the classroom",
    "icon": "/images/icons/secret.png"
  },
  "1774497583574-OKBBAo2RM44OS9DjaPrHxwrU-prizepack": {
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "event": "Prize Pack Earned",
    "id": "1774497583574-OKBBAo2RM44OS9DjaPrHxwrU-prizepack",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "ts": 1774497583574,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "title": "The Tribute Chest",
    "activity": "New Prize Pack",
    "spec": "",
    "display": "prizepack",
    "rewardIds": [
      "1772230537890-86781-LNymX-item",
      "1772230537866-86781-LNymX-item",
      "1772230537888-86781-LNymX-item"
    ],
    "data": {
      "1774497583576-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
        "title": "Item Earned: Aureus Coin",
        "quantity": 1,
        "type": "items",
        "id": "1772230537866-86781-LNymX-item"
      },
      "1774497583577-items": {
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
        "title": "Item Earned: Jupiter's Thunderbolt",
        "id": "1772230537888-86781-LNymX-item",
        "type": "items"
      },
      "1774497583575-items": {
        "quantity": 1,
        "title": "Item Earned: Minerva's Owl",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295099861-Inventory%20Item.png?alt=media&token=0d29ad82-fe6e-4e33-88ee-f8cf6a872b48",
        "id": "1772230537890-86781-LNymX-item",
        "type": "items"
      }
    },
    "type": "rewards",
    "path": "g-ztcpngvv6qzvpk3r"
  },
  "1774497798483-OKBBAo2RM44OS9DjaPrHxwrU-secretCode": {
    "ts": 1774497798483,
    "info": "Solution to a weekly puzzle",
    "icon": "/images/icons/secret.png",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772595348387-86781-LNymX-secretCode",
    "event": "Secret Code Found",
    "id": "1774497798483-OKBBAo2RM44OS9DjaPrHxwrU-secretCode",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "display": "reward",
    "rewardIds": [
      "1772595348387-86781-LNymX-secretCode",
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "data": {
      "1774497798485dss28-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "cost": 500,
        "type": "prizepack",
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest"
      },
      "17744977984843w4q8-currency": {
        "quantity": 50,
        "icon": "/images/icons/currency.png",
        "title": "$50 Earned",
        "id": "currency",
        "type": "currency"
      }
    },
    "type": "secretCode",
    "path": "koxw4p4r27nzrt0nhf",
    "title": "SATURAE-380",
    "activity": "Secret Code Found",
    "comments": ""
  },
  "1774497798486-OKBBAo2RM44OS9DjaPrHxwrU-prizepack": {
    "info": "",
    "ts": 1774497798486,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "id": "1774497798486-OKBBAo2RM44OS9DjaPrHxwrU-prizepack",
    "event": "Prize Pack Earned",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "display": "prizepack",
    "rewardIds": [
      "1772230537868-86781-LNymX-item",
      "1772230537891-86781-LNymX-item",
      "1772230537889-86781-LNymX-item"
    ],
    "data": {
      "1774497798487-items": {
        "title": "Item Earned: Fragment of a Roman Mosaic Tile",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad",
        "quantity": 1,
        "type": "items",
        "id": "1772230537868-86781-LNymX-item"
      },
      "1774497798489-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295527734-Inventory%20Item.png?alt=media&token=84f0a9dc-39d9-492c-9bdf-4309442405ad",
        "title": "Item Earned: Neptune's Trident",
        "quantity": 1,
        "type": "items",
        "id": "1772230537889-86781-LNymX-item"
      },
      "1774497798488-items": {
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295414866-final-sandal.png?alt=media&token=72853a72-1622-45c1-aae9-f5d9dea654dc",
        "title": "Item Earned: Mercury's Winged Sandal",
        "id": "1772230537891-86781-LNymX-item",
        "type": "items"
      }
    },
    "type": "rewards",
    "path": "qp369ue-2ya_-cryfv",
    "activity": "New Prize Pack",
    "spec": "",
    "title": "The Tribute Chest"
  },
  "1774497798490-OKBBAo2RM44OS9DjaPrHxwrU-collectionCompleted": {
    "path": "ozxcyrone50a6cq4su",
    "type": "collections",
    "data": {
      "1774497798492oou4s-item": {
        "type": "item",
        "cost": 0,
        "id": "1772230537887-86781-LNymX-item",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306152881-Access%20Item%20(1).png?alt=media&token=9572a5ae-5f50-4478-9e76-0e5f361ddeea",
        "title": "Item Earned: The Signet Ring (Seal of Authority)",
        "quantity": 1
      },
      "1774497798491jsnsb-currency": {
        "quantity": 300,
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "id": "currency",
        "type": "currency"
      }
    },
    "display": "achievement",
    "rewardIds": [
      "currency",
      "1772230537887-86781-LNymX-item"
    ],
    "title": "The Pantheons Favor",
    "spec": "OKBBAo2RM44OS9DjaPrHxwrU-1772233183963-86781-LNymX-collection",
    "activity": "Collection Completed",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772233182186-Collectible.jpg?alt=media&token=1d3d9f0b-182c-424c-83af-957fc7dd64b3",
    "ts": 1774497798490,
    "info": "Collect all of the gods' artifacts to gain access to a new set of challenges!",
    "elementId": "1772233183963-86781-LNymX-collection",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "event": "Collection Completed",
    "id": "1774497798490-OKBBAo2RM44OS9DjaPrHxwrU-collectionCompleted"
  },
  "1774497967887-OKBBAo2RM44OS9DjaPrHxwrU-secretCode": {
    "elementId": "1772595348384-86781-LNymX-secretCode",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "event": "Secret Code Found",
    "id": "1774497967887-OKBBAo2RM44OS9DjaPrHxwrU-secretCode",
    "icon": "/images/icons/secret.png",
    "ts": 1774497967887,
    "info": "Solution to a weekly puzzle",
    "title": "STYLUS-632",
    "comments": "",
    "activity": "Secret Code Found",
    "path": "9f7zgy8e-dqcj3y3ok",
    "type": "secretCode",
    "data": {
      "1774497967889x92je-prizepack": {
        "cost": 500,
        "type": "prizepack",
        "id": "1772590997526-86781-LNymX-prizepack",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest",
        "quantity": 1
      },
      "1774497967888mytfq-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 50,
        "icon": "/images/icons/currency.png",
        "title": "$50 Earned"
      }
    },
    "rewardIds": [
      "1772595348384-86781-LNymX-secretCode",
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "display": "reward"
  },
  "1774497967890-OKBBAo2RM44OS9DjaPrHxwrU-prizepack": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "ts": 1774497967890,
    "info": "",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "event": "Prize Pack Earned",
    "id": "1774497967890-OKBBAo2RM44OS9DjaPrHxwrU-prizepack",
    "path": "9mhcjja5sud9eica9u",
    "type": "rewards",
    "data": {
      "1774497967893-items": {
        "title": "Item Earned: Miniature Legionary Helmet",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
        "quantity": 1,
        "type": "items",
        "id": "1772230537870-86781-LNymX-item"
      },
      "1774497967892-items": {
        "quantity": 1,
        "title": "Item Earned: Miniature Legionary Helmet",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
        "id": "1772230537870-86781-LNymX-item",
        "type": "items"
      },
      "1774497967891-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
        "title": "Item Earned: Miniature Legionary Helmet",
        "quantity": 1,
        "type": "items",
        "id": "1772230537870-86781-LNymX-item"
      }
    },
    "display": "prizepack",
    "rewardIds": [
      "1772230537870-86781-LNymX-item",
      "1772230537870-86781-LNymX-item",
      "1772230537870-86781-LNymX-item"
    ],
    "title": "The Tribute Chest",
    "spec": "",
    "activity": "New Prize Pack"
  },
  "1774498029778-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge": {
    "display": "playerActivity",
    "rewardIds": [
      "1772569770551-86781-LNymX-challenge"
    ],
    "type": "actionItem",
    "path": "6ert-q-qfqpibyde86",
    "title": "The Forum Oration",
    "activity": "Challenge Submitted",
    "ts": 1774498029778,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "appId": "",
    "elementId": "1772569770551-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774498029778-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge",
    "event": "Challenge Submitted",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU"
  },
  "1774498048484-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge": {
    "elementId": "1772569770551-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Approved",
    "id": "1774498048484-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge",
    "elementPath": "60d4y80ktqectdx0xc",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "ts": 1774498048484,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Forum Oration",
    "activity": "Challenge Approved",
    "comments": "Excellent video!",
    "data": {
      "1774498048486864fe-currency": {
        "quantity": 300,
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "id": "currency",
        "type": "currency"
      },
      "1774498048485ndbzq-points": {
        "id": "xp",
        "type": "xp",
        "quantity": 300,
        "title": "300 XP Earned",
        "icon": "/images/xp.png"
      }
    },
    "display": "achievement",
    "rewardIds": [
      "1772569770551-86781-LNymX-challenge",
      "xp",
      "currency"
    ],
    "actionItemId": "1774498029778-86781-LNymX-challenge-actionitem",
    "path": "6n55-bybb7d24_7j8r",
    "type": "approvedChallenge"
  },
  "1774501243641-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge": {
    "appId": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572117328-journey.png?alt=media&token=7cad1335-9e37-484d-ba59-8f8f6bb99a9d",
    "ts": 1774501243641,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "event": "Challenge Submitted",
    "id": "1774501243641-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772572118651-86781-LNymX-challenge",
    "path": "-2__w4_nfbp-453679",
    "type": "actionItem",
    "rewardIds": [
      "1772572118651-86781-LNymX-challenge"
    ],
    "display": "playerActivity",
    "activity": "Challenge Submitted",
    "title": "The Architects Blueprint"
  },
  "1774501436178-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572117328-journey.png?alt=media&token=7cad1335-9e37-484d-ba59-8f8f6bb99a9d",
    "ts": 1774501436178,
    "elementPath": "q8uk_4hwijmpaw2ef4",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "event": "Challenge Approved",
    "id": "1774501436178-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772572118651-86781-LNymX-challenge",
    "type": "approvedChallenge",
    "path": "mdm_873_ik5xx5w34c",
    "actionItemId": "1774501243641-86781-LNymX-challenge-actionitem",
    "display": "achievement",
    "rewardIds": [
      "1772572118651-86781-LNymX-challenge",
      "xp",
      "currency"
    ],
    "data": {
      "17745014361804hshf-currency": {
        "quantity": 300,
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "id": "currency",
        "type": "currency"
      },
      "1774501436179mwiqk-points": {
        "title": "300 XP Earned",
        "icon": "/images/xp.png",
        "quantity": 300,
        "type": "xp",
        "id": "xp"
      }
    },
    "comments": "Well done!",
    "activity": "Challenge Approved",
    "title": "The Architects Blueprint"
  },
  "1774501446838-OKBBAo2RM44OS9DjaPrHxwrU-level": {
    "type": "levels",
    "path": "bpuovi3aeuf8ubu223",
    "rewardIds": [
      "1772590711756-86781-LNymX-level",
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "display": "achievement",
    "data": {
      "17745014468403kn3g-prizepack": {
        "type": "prizepack",
        "cost": 500,
        "id": "1772590997526-86781-LNymX-prizepack",
        "title": "Prize Pack Earned: The Tribute Chest",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "quantity": 1
      },
      "1774501446839amgdr-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 200,
        "icon": "/images/icons/currency.png",
        "title": "$200 Earned"
      }
    },
    "title": "Civis (The Citizen):",
    "activity": "Level Earned",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597828647-civis.png?alt=media&token=faa1c836-1f43-4563-8d03-5c72b25fa8a5",
    "info": "You have proven your basic literacy and are now a full member of the literary republic, entitled to participate in more complex quests.",
    "ts": 1774501446838,
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590711756-86781-LNymX-level",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "event": "Level Earned",
    "id": "1774501446838-OKBBAo2RM44OS9DjaPrHxwrU-level"
  },
  "1774535368932-ZvZ0CMN6ywykvdvTHuOPvRKz-level": {
    "display": "achievement",
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "data": {
      "1774535368933k92wv-currency": {
        "quantity": 200,
        "icon": "/images/icons/currency.png",
        "title": "$200 Earned",
        "id": "currency",
        "type": "currency"
      }
    },
    "path": "emmgv6chyk627n0cd9",
    "type": "levels",
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned",
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "ts": 1774535368932,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590648474-86781-LNymX-level",
    "id": "1774535368932-ZvZ0CMN6ywykvdvTHuOPvRKz-level",
    "event": "Level Earned",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz"
  },
  "1774535391303-ZvZ0CMN6ywykvdvTHuOPvRKz-purchase": {
    "cartQuantity": 1,
    "icon": "/images/icons/shopping-cart.png",
    "info": "",
    "ts": 1774535391303,
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "event": "Purchase Completed",
    "id": "1774535391303-ZvZ0CMN6ywykvdvTHuOPvRKz-purchase",
    "gameId": "1772165586781-LNymXRI-game",
    "type": "purchase",
    "cartTotal": 200,
    "path": "6xpo_otpr2hsh_eiz3",
    "data": {
      "1774535391305fytqk-item": {
        "id": "1772230537881-86781-LNymX-item",
        "itemType": "inventory",
        "saleId": "",
        "cost": 200,
        "title": "Item Purchased: The Aegis of Aeneas",
        "type": "item",
        "quantity": 1,
        "name": "The Aegis of Aeneas",
        "purchase": true,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303141509-Inventory%20Item%20(2).png?alt=media&token=4f138801-ddcf-4f5e-bd16-824a301c8b03"
      }
    },
    "display": "purchase",
    "rewardIds": [
      "currency",
      "1772230537881-86781-LNymX-item"
    ],
    "spec": 200,
    "userName": "Sofia Ricci",
    "activity": "Purchase Completed",
    "title": "Purchase Completed"
  },
  "1774535538361-ZvZ0CMN6ywykvdvTHuOPvRKz-submittedChallenge": {
    "appId": "",
    "ts": 1774535538361,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
    "id": "1774535538361-ZvZ0CMN6ywykvdvTHuOPvRKz-submittedChallenge",
    "event": "Challenge Submitted",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "elementId": "1772569886040-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "playerActivity",
    "rewardIds": [
      "1772569886040-86781-LNymX-challenge"
    ],
    "type": "actionItem",
    "path": "ow4nupsthq9brn6oq3",
    "activity": "Challenge Submitted",
    "title": "Veni, Vidi, Vici"
  },
  "1774535571480-1772569886040-86781-LNymX-challenge-edited": {
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Veni, Vidi, Vici has been edited.",
    "display": "managerActivity",
    "type": "editedChallenge",
    "path": "hxdge0t66vcebu-ay8",
    "id": "1774535571480-1772569886040-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774535571480,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945"
  },
  "1774535601047-ZvZ0CMN6ywykvdvTHuOPvRKz-secretCode": {
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "event": "Secret Code Found",
    "id": "1774535601047-ZvZ0CMN6ywykvdvTHuOPvRKz-secretCode",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772595348385-86781-LNymX-secretCode",
    "icon": "/images/icons/secret.png",
    "ts": 1774535601047,
    "info": "Hidden in a book in the library",
    "comments": "",
    "activity": "Secret Code Found",
    "title": "CODEX-090",
    "type": "secretCode",
    "path": "juuw4ecd330zy_462f",
    "rewardIds": [
      "1772595348385-86781-LNymX-secretCode",
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "display": "reward",
    "data": {
      "1774535601049bvc79-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "type": "prizepack",
        "cost": 500,
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest"
      },
      "1774535601048fdm3o-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 50,
        "icon": "/images/icons/currency.png",
        "title": "$50 Earned"
      }
    }
  },
  "1774535601050-ZvZ0CMN6ywykvdvTHuOPvRKz-prizepack": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "ts": 1774535601050,
    "info": "",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "event": "Prize Pack Earned",
    "id": "1774535601050-ZvZ0CMN6ywykvdvTHuOPvRKz-prizepack",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "gameId": "1772165586781-LNymXRI-game",
    "type": "rewards",
    "path": "8_t7hpoqe2tyxzb3hu",
    "data": {
      "1774535601053-items": {
        "type": "items",
        "id": "1772230537888-86781-LNymX-item",
        "title": "Item Earned: Jupiter's Thunderbolt",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
        "quantity": 1
      },
      "1774535601051-items": {
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295099861-Inventory%20Item.png?alt=media&token=0d29ad82-fe6e-4e33-88ee-f8cf6a872b48",
        "title": "Item Earned: Minerva's Owl",
        "id": "1772230537890-86781-LNymX-item",
        "type": "items"
      },
      "1774535601052-items": {
        "id": "1772230537866-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
        "title": "Item Earned: Aureus Coin"
      }
    },
    "display": "prizepack",
    "rewardIds": [
      "1772230537890-86781-LNymX-item",
      "1772230537866-86781-LNymX-item",
      "1772230537888-86781-LNymX-item"
    ],
    "spec": "",
    "activity": "New Prize Pack",
    "title": "The Tribute Chest"
  },
  "1774535749100-1772571789776-86781-LNymX-challenge-edited": {
    "display": "managerActivity",
    "type": "editedChallenge",
    "path": "thsimp5vgfdo5_jxu6",
    "activity": "Challenge Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Amphitheater Critique has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774535749100,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571788594-amphitheater.png?alt=media&token=6d415076-c1b0-426a-adc3-380ed60f1b6e",
    "id": "1774535749100-1772571789776-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774536340963-ZvZ0CMN6ywykvdvTHuOPvRKz-submittedChallenge": {
    "activity": "Challenge Submitted",
    "title": "The Forum Oration",
    "rewardIds": [
      "1772569770551-86781-LNymX-challenge"
    ],
    "display": "playerActivity",
    "type": "actionItem",
    "path": "eknhxnr20xi9rci7wt",
    "event": "Challenge Submitted",
    "id": "1774536340963-ZvZ0CMN6ywykvdvTHuOPvRKz-submittedChallenge",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "elementId": "1772569770551-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "",
    "ts": 1774536340963,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb"
  },
  "1774570826805-2Vo46bD7t6SWCo7PN9MPZME5-level": {
    "path": "b2yx-gw4fdro23y-mz",
    "type": "levels",
    "display": "achievement",
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "data": {
      "1774570826806vqxpd-currency": {
        "quantity": 200,
        "icon": "/images/icons/currency.png",
        "title": "$200 Earned",
        "id": "currency",
        "type": "currency"
      }
    },
    "activity": "Level Earned",
    "title": "Tiro (The Recruit)",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "ts": 1774570826805,
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "id": "1774570826805-2Vo46bD7t6SWCo7PN9MPZME5-level",
    "event": "Level Earned",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590648474-86781-LNymX-level"
  },
  "1774571331255-1772569834612-86781-LNymX-challenge-edited": {
    "display": "managerActivity",
    "path": "c4bt_6vuu58t6ko97i",
    "type": "editedChallenge",
    "title": "The Sibylline Prophecy has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "ts": 1774571331255,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Edited",
    "id": "1774571331255-1772569834612-86781-LNymX-challenge-edited"
  },
  "1774571359657-1772569834612-86781-LNymX-challenge-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774571359657-1772569834612-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "info": "",
    "ts": 1774571359657,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Sibylline Prophecy has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "type": "editedChallenge",
    "path": "umvx_hkqo-swkp5-bk"
  },
  "1774571645810-2Vo46bD7t6SWCo7PN9MPZME5-submittedChallenge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "ts": 1774571645810,
    "appId": "",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569834612-86781-LNymX-challenge",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "event": "Challenge Submitted",
    "id": "1774571645810-2Vo46bD7t6SWCo7PN9MPZME5-submittedChallenge",
    "type": "actionItem",
    "path": "c9ysm-vb-63fjf98c9",
    "rewardIds": [
      "1772569834612-86781-LNymX-challenge"
    ],
    "display": "playerActivity",
    "title": "The Sibylline Prophecy",
    "activity": "Challenge Submitted"
  },
  "1774571686524-2Vo46bD7t6SWCo7PN9MPZME5-submittedChallenge": {
    "rewardIds": [
      "1772569770551-86781-LNymX-challenge"
    ],
    "display": "playerActivity",
    "path": "f70dqadaz85pcd5dzp",
    "type": "actionItem",
    "activity": "Challenge Submitted",
    "title": "The Forum Oration",
    "appId": "",
    "ts": 1774571686524,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "id": "1774571686524-2Vo46bD7t6SWCo7PN9MPZME5-submittedChallenge",
    "event": "Challenge Submitted",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569770551-86781-LNymX-challenge"
  },
  "1774572338000-ZvZ0CMN6ywykvdvTHuOPvRKz-approvedChallenge": {
    "title": "Veni, Vidi, Vici",
    "comments": "Great summary! I hope you enjoy the book!",
    "activity": "Challenge Approved",
    "path": "gi_apu56mxsupxd08j",
    "type": "approvedChallenge",
    "actionItemId": "1774535538361-86781-LNymX-challenge-actionitem",
    "display": "achievement",
    "rewardIds": [
      "1772569886040-86781-LNymX-challenge",
      "xp",
      "currency"
    ],
    "data": {
      "1774572338002hfcns-currency": {
        "quantity": 150,
        "title": "$150 Earned",
        "icon": "/images/icons/currency.png",
        "id": "currency",
        "type": "currency"
      },
      "1774572338001x8z9j-points": {
        "title": "150 XP Earned",
        "icon": "/images/xp.png",
        "quantity": 150,
        "type": "xp",
        "id": "xp"
      }
    },
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569886040-86781-LNymX-challenge",
    "elementPath": "29bwi-ah-6h4cpdhvk",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "id": "1774572338000-ZvZ0CMN6ywykvdvTHuOPvRKz-approvedChallenge",
    "event": "Challenge Approved",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
    "ts": 1774572338000,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774572403947-ZvZ0CMN6ywykvdvTHuOPvRKz-declinedChallenge": {
    "actionItemId": "1774536340963-86781-LNymX-challenge-actionitem",
    "type": "declinedChallenge",
    "path": "cdd3wkmxdzbhfpjgk5",
    "data": {},
    "rewardIds": [
      "1772569770551-86781-LNymX-challenge"
    ],
    "display": "playerActivity",
    "comments": "Sorry, that didn't meet the requirements. Try again and upload your new video. Be sure to focus on emulating the way we think Romans would have sounded based on your reading.",
    "activity": "Challenge Declined",
    "title": "The Forum Oration",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "ts": 1774572403947,
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "elementPath": "60d4y80ktqectdx0xc",
    "event": "Challenge Declined",
    "id": "1774572403947-ZvZ0CMN6ywykvdvTHuOPvRKz-declinedChallenge",
    "elementId": "1772569770551-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774572421960-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "ts": 1774572421960,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569834612-86781-LNymX-challenge",
    "elementPath": "4zbqmstr9c9jjc24ux",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "event": "Challenge Approved",
    "id": "1774572421960-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge",
    "type": "approvedChallenge",
    "path": "zi5qurnu9gw-gt_0uc",
    "actionItemId": "1774571645810-86781-LNymX-challenge-actionitem",
    "display": "achievement",
    "rewardIds": [
      "1772569834612-86781-LNymX-challenge",
      "xp",
      "currency"
    ],
    "data": {
      "1774572421962twsqr-currency": {
        "id": "currency",
        "type": "currency",
        "quantity": 150,
        "title": "$150 Earned",
        "icon": "/images/icons/currency.png"
      },
      "1774572421961qtesd-points": {
        "id": "xp",
        "type": "xp",
        "quantity": 150,
        "icon": "/images/xp.png",
        "title": "150 XP Earned"
      }
    },
    "title": "The Sibylline Prophecy",
    "comments": "Great prophecy! That's a fantastic novel.",
    "activity": "Challenge Approved"
  },
  "1774572434610-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge": {
    "elementId": "1772569770551-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "elementPath": "60d4y80ktqectdx0xc",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "event": "Challenge Approved",
    "id": "1774572434610-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "ts": 1774572434610,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "The Forum Oration",
    "comments": "Excellent!",
    "activity": "Challenge Approved",
    "actionItemId": "1774571686524-86781-LNymX-challenge-actionitem",
    "type": "approvedChallenge",
    "path": "qre58mqq2yj6f9-d-z",
    "data": {
      "1774572434611gv5bd-points": {
        "id": "xp",
        "type": "xp",
        "quantity": 300,
        "title": "300 XP Earned",
        "icon": "/images/xp.png"
      },
      "1774572434612hj2vq-currency": {
        "title": "$300 Earned",
        "icon": "/images/icons/currency.png",
        "quantity": 300,
        "type": "currency",
        "id": "currency"
      }
    },
    "display": "achievement",
    "rewardIds": [
      "1772569770551-86781-LNymX-challenge",
      "xp",
      "currency"
    ]
  },
  "1774572899758-2Vo46bD7t6SWCo7PN9MPZME5-purchase": {
    "display": "purchase",
    "rewardIds": [
      "currency",
      "1772230537882-86781-LNymX-item",
      "1772230537869-86781-LNymX-item",
      "1772230537874-86781-LNymX-item"
    ],
    "data": {
      "1774572899764tq4rw-item": {
        "type": "item",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554064109-Inventory%20Item%20(9).png?alt=media&token=24dc2242-4a6e-4408-92ab-e30dc774b072",
        "purchase": true,
        "name": "Pilleus Libertatis (Hat Pass for a Day)",
        "quantity": 1,
        "saleId": "",
        "cost": 100,
        "itemType": "inventory",
        "id": "1772230537874-86781-LNymX-item",
        "title": "Item Purchased: Pilleus Libertatis (Hat Pass for a Day)"
      },
      "1774572899763zu3rz-item": {
        "saleId": "",
        "cost": 100,
        "id": "1772230537869-86781-LNymX-item",
        "itemType": "inventory",
        "title": "Item Purchased: Magister's Legatus (Teacher's Helper for a Day)",
        "type": "item",
        "purchase": true,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553695485-Inventory%20Item%20(7).png?alt=media&token=720d5f6e-2ad6-4c50-82b8-de7fe34d7874",
        "quantity": 1,
        "name": "Magister's Legatus (Teacher's Helper for a Day)"
      },
      "1774572899762zesit-item": {
        "type": "item",
        "purchase": true,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303244750-Inventory%20Item%20(3).png?alt=media&token=8755aa8b-307b-4316-b462-ce838cacdaf5",
        "quantity": 1,
        "name": "The Janus Key",
        "saleId": "",
        "cost": 200,
        "id": "1772230537882-86781-LNymX-item",
        "itemType": "inventory",
        "title": "Item Purchased: The Janus Key"
      }
    },
    "path": "h7ng8qf6o3bybmdysi",
    "cartTotal": 400,
    "type": "purchase",
    "activity": "Purchase Completed",
    "userName": "Julian Sterling",
    "spec": 400,
    "title": "Purchase Completed",
    "cartQuantity": 3,
    "info": "",
    "ts": 1774572899758,
    "icon": "/images/icons/shopping-cart.png",
    "id": "1774572899758-2Vo46bD7t6SWCo7PN9MPZME5-purchase",
    "event": "Purchase Completed",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774615595943-JSx4p6pOdtEAGMvzmX3AcbwT-level": {
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned",
    "data": {
      "1774615595944m2uw7-currency": {
        "quantity": 200,
        "icon": "/images/icons/currency.png",
        "title": "$200 Earned",
        "id": "currency",
        "type": "currency"
      }
    },
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "display": "achievement",
    "type": "levels",
    "path": "_xpve90ar8j2awqkw6",
    "elementId": "1772590648474-86781-LNymX-level",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Level Earned",
    "id": "1774615595943-JSx4p6pOdtEAGMvzmX3AcbwT-level",
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "ts": 1774615595943,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6"
  },
  "1774615663445-axOQve3xXxzhqJ7OPczuoZFm-rewards": {
    "icon": "/images/icons/treasure.png",
    "info": "Thank you for everything you did to help our school",
    "ts": 1774615663445,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "id": "1774615663445-axOQve3xXxzhqJ7OPczuoZFm-rewards",
    "event": "Rewards Earned",
    "type": "rewards",
    "path": "uwhawx-j_62yr98_m-",
    "data": {
      "1774615663448brf65-prizepack": {
        "cost": 500,
        "type": "prizepack",
        "id": "1772590997526-86781-LNymX-prizepack",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest",
        "quantity": 1
      },
      "17746156634476zbkx-currency": {
        "type": "currency",
        "id": "currency",
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "quantity": 300
      }
    },
    "display": "reward",
    "rewardIds": [
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "title": "Reward: School Safety Help",
    "spec": "",
    "activity": "Rewards Earned"
  },
  "1774615663446-YF29Cw25nRFWUe6t37OtFiwm-rewards": {
    "ts": 1774615663446,
    "info": "Thank you for everything you did to help our school",
    "icon": "/images/icons/treasure.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Rewards Earned",
    "id": "1774615663446-YF29Cw25nRFWUe6t37OtFiwm-rewards",
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "data": {
      "1774615663449uoeqs-prizepack": {
        "type": "prizepack",
        "cost": 500,
        "id": "1772590997526-86781-LNymX-prizepack",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest",
        "quantity": 1
      },
      "1774615663448tcko3-currency": {
        "quantity": 300,
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "id": "currency",
        "type": "currency"
      }
    },
    "rewardIds": [
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "display": "reward",
    "type": "rewards",
    "path": "vuzv5yg8nj2t7ct33n",
    "title": "Reward: School Safety Help",
    "activity": "Rewards Earned",
    "spec": ""
  },
  "1774615663447-ZvZ0CMN6ywykvdvTHuOPvRKz-rewards": {
    "title": "Reward: School Safety Help",
    "spec": "",
    "activity": "Rewards Earned",
    "type": "rewards",
    "path": "ai0h78e8q2wpkc8x5n",
    "rewardIds": [
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "display": "reward",
    "data": {
      "17746156634505u9j7-prizepack": {
        "quantity": 1,
        "title": "Prize Pack Earned: The Tribute Chest",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "id": "1772590997526-86781-LNymX-prizepack",
        "cost": 500,
        "type": "prizepack"
      },
      "1774615663449t8thw-currency": {
        "type": "currency",
        "id": "currency",
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "quantity": 300
      }
    },
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "event": "Rewards Earned",
    "id": "1774615663447-ZvZ0CMN6ywykvdvTHuOPvRKz-rewards",
    "icon": "/images/icons/treasure.png",
    "info": "Thank you for everything you did to help our school",
    "ts": 1774615663447,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774615663448-2Vo46bD7t6SWCo7PN9MPZME5-rewards": {
    "title": "Reward: School Safety Help",
    "activity": "Rewards Earned",
    "spec": "",
    "display": "reward",
    "rewardIds": [
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "data": {
      "1774615663451kh4hf-prizepack": {
        "cost": 500,
        "type": "prizepack",
        "id": "1772590997526-86781-LNymX-prizepack",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest",
        "quantity": 1
      },
      "1774615663450it6h6-currency": {
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "quantity": 300,
        "type": "currency",
        "id": "currency"
      }
    },
    "type": "rewards",
    "path": "v6hg3743zuqp9_eexv",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774615663448-2Vo46bD7t6SWCo7PN9MPZME5-rewards",
    "event": "Rewards Earned",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "info": "Thank you for everything you did to help our school",
    "ts": 1774615663448,
    "icon": "/images/icons/treasure.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774615663449-A9Z54ybEdO08J7BH5Mpynx03-rewards": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "/images/icons/treasure.png",
    "ts": 1774615663449,
    "info": "Thank you for everything you did to help our school",
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "event": "Rewards Earned",
    "id": "1774615663449-A9Z54ybEdO08J7BH5Mpynx03-rewards",
    "gameId": "1772165586781-LNymXRI-game",
    "path": "a2s95trvjxpq4jo8_4",
    "type": "rewards",
    "data": {
      "1774615663452gujcf-prizepack": {
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest",
        "id": "1772590997526-86781-LNymX-prizepack",
        "type": "prizepack",
        "cost": 500
      },
      "1774615663451xqfia-currency": {
        "type": "currency",
        "id": "currency",
        "icon": "/images/icons/currency.png",
        "title": "$300 Earned",
        "quantity": 300
      }
    },
    "display": "reward",
    "rewardIds": [
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "spec": "",
    "activity": "Rewards Earned",
    "title": "Reward: School Safety Help"
  },
  "1774615663449-axOQve3xXxzhqJ7OPczuoZFm-prizepack": {
    "ts": 1774615663449,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Prize Pack Earned",
    "id": "1774615663449-axOQve3xXxzhqJ7OPczuoZFm-prizepack",
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "data": {
      "1774615663451-items": {
        "type": "items",
        "id": "1772230537866-86781-LNymX-item",
        "title": "Item Earned: Aureus Coin",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
        "quantity": 1
      },
      "1774615663452-items": {
        "id": "1772230537868-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "title": "Item Earned: Fragment of a Roman Mosaic Tile",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad"
      },
      "1774615663450-items": {
        "type": "items",
        "id": "1772230537866-86781-LNymX-item",
        "title": "Item Earned: Aureus Coin",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
        "quantity": 1
      }
    },
    "display": "prizepack",
    "rewardIds": [
      "1772230537866-86781-LNymX-item",
      "1772230537866-86781-LNymX-item",
      "1772230537868-86781-LNymX-item"
    ],
    "type": "rewards",
    "path": "em4e9hmidpimepwsfx",
    "title": "The Tribute Chest",
    "activity": "New Prize Pack",
    "spec": ""
  },
  "1774615663450-YF29Cw25nRFWUe6t37OtFiwm-prizepack": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "info": "",
    "ts": 1774615663450,
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "event": "Prize Pack Earned",
    "id": "1774615663450-YF29Cw25nRFWUe6t37OtFiwm-prizepack",
    "type": "rewards",
    "path": "_p7ypn9tj0kz0_ob-0",
    "data": {
      "1774615663452-items": {
        "title": "Item Earned: Neptune's Trident",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295527734-Inventory%20Item.png?alt=media&token=84f0a9dc-39d9-492c-9bdf-4309442405ad",
        "quantity": 1,
        "type": "items",
        "id": "1772230537889-86781-LNymX-item"
      },
      "1774615663451-items": {
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295099861-Inventory%20Item.png?alt=media&token=0d29ad82-fe6e-4e33-88ee-f8cf6a872b48",
        "title": "Item Earned: Minerva's Owl",
        "id": "1772230537890-86781-LNymX-item",
        "type": "items"
      },
      "1774615663453-items": {
        "id": "1772230537875-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "title": "Item Earned: Scroll Fragment",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b"
      }
    },
    "display": "prizepack",
    "rewardIds": [
      "1772230537890-86781-LNymX-item",
      "1772230537889-86781-LNymX-item",
      "1772230537875-86781-LNymX-item"
    ],
    "title": "The Tribute Chest",
    "spec": "",
    "activity": "New Prize Pack"
  },
  "1774615663451-LNymXRIM2ASSsSrLza6lfvWLXKz2-bulkDist": {
    "display": "managerActivity",
    "data": {
      "logs": [
        {
          "playerName": "Cross, Xavier",
          "message": "Currency awarded: 300",
          "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
          "status": "success"
        },
        {
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
          "message": "Prize Pack awarded: \"The Tribute Chest\"",
          "playerName": "Cross, Xavier"
        },
        {
          "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
          "status": "success",
          "playerName": "Maxwell, Leo",
          "message": "Currency awarded: 300"
        },
        {
          "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
          "status": "success",
          "playerName": "Maxwell, Leo",
          "message": "Prize Pack awarded: \"The Tribute Chest\""
        },
        {
          "playerName": "Ricci, Sofia",
          "message": "Currency awarded: 300",
          "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
          "status": "success"
        },
        {
          "message": "Prize Pack awarded: \"The Tribute Chest\"",
          "playerName": "Ricci, Sofia",
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz"
        },
        {
          "playerName": "Sterling, Julian",
          "message": "Currency awarded: 300",
          "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
          "status": "success"
        },
        {
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
          "message": "Prize Pack awarded: \"The Tribute Chest\"",
          "playerName": "Sterling, Julian"
        },
        {
          "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
          "status": "success",
          "playerName": "Vane, Silas",
          "message": "Currency awarded: 300"
        },
        {
          "message": "Prize Pack awarded: \"The Tribute Chest\"",
          "playerName": "Vane, Silas",
          "status": "success",
          "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03"
        }
      ]
    },
    "type": "activityLog",
    "path": "jz5snghxx_0-9waam7",
    "activity": "Bulk Distribution",
    "spec": "",
    "title": "Reward: School Safety Help",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "Thank you for everything you did to help our school",
    "ts": 1774615663451,
    "icon": "/images/icons/treasure.png",
    "id": "1774615663451-LNymXRIM2ASSsSrLza6lfvWLXKz2-bulkDist",
    "event": "Bulk Distribution",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774615663451-ZvZ0CMN6ywykvdvTHuOPvRKz-prizepack": {
    "rewardIds": [
      "1772230537875-86781-LNymX-item",
      "1772230537868-86781-LNymX-item",
      "1772230537868-86781-LNymX-item"
    ],
    "display": "prizepack",
    "data": {
      "1774615663452-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b",
        "title": "Item Earned: Scroll Fragment",
        "quantity": 1,
        "type": "items",
        "id": "1772230537875-86781-LNymX-item"
      },
      "1774615663453-items": {
        "title": "Item Earned: Fragment of a Roman Mosaic Tile",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad",
        "quantity": 1,
        "type": "items",
        "id": "1772230537868-86781-LNymX-item"
      },
      "1774615663454-items": {
        "id": "1772230537868-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad",
        "title": "Item Earned: Fragment of a Roman Mosaic Tile"
      }
    },
    "type": "rewards",
    "path": "0z36v6z8ti83a05sqn",
    "activity": "New Prize Pack",
    "spec": "",
    "title": "The Tribute Chest",
    "info": "",
    "ts": 1774615663451,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "event": "Prize Pack Earned",
    "id": "1774615663451-ZvZ0CMN6ywykvdvTHuOPvRKz-prizepack",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590997526-86781-LNymX-prizepack"
  },
  "1774615663452-2Vo46bD7t6SWCo7PN9MPZME5-prizepack": {
    "data": {
      "1774615663454-items": {
        "id": "1772230537891-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295414866-final-sandal.png?alt=media&token=72853a72-1622-45c1-aae9-f5d9dea654dc",
        "title": "Item Earned: Mercury's Winged Sandal"
      },
      "1774615663453-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
        "title": "Item Earned: Jupiter's Thunderbolt",
        "quantity": 1,
        "type": "items",
        "id": "1772230537888-86781-LNymX-item"
      },
      "1774615663455-items": {
        "quantity": 1,
        "title": "Item Earned: Jupiter's Thunderbolt",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
        "id": "1772230537888-86781-LNymX-item",
        "type": "items"
      }
    },
    "rewardIds": [
      "1772230537888-86781-LNymX-item",
      "1772230537891-86781-LNymX-item",
      "1772230537888-86781-LNymX-item"
    ],
    "display": "prizepack",
    "type": "rewards",
    "path": "p4omt3cdi8_sy-4s_g",
    "activity": "New Prize Pack",
    "spec": "",
    "title": "The Tribute Chest",
    "info": "",
    "ts": 1774615663452,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "event": "Prize Pack Earned",
    "id": "1774615663452-2Vo46bD7t6SWCo7PN9MPZME5-prizepack",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774615663453-A9Z54ybEdO08J7BH5Mpynx03-prizepack": {
    "event": "Prize Pack Earned",
    "id": "1774615663453-A9Z54ybEdO08J7BH5Mpynx03-prizepack",
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "gameId": "1772165586781-LNymXRI-game",
    "info": "",
    "ts": 1774615663453,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "activity": "New Prize Pack",
    "spec": "",
    "title": "The Tribute Chest",
    "data": {
      "1774615663454-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
        "title": "Item Earned: Aureus Coin",
        "quantity": 1,
        "type": "items",
        "id": "1772230537866-86781-LNymX-item"
      },
      "1774615663455-items": {
        "quantity": 1,
        "title": "Item Earned: Aureus Coin",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
        "id": "1772230537866-86781-LNymX-item",
        "type": "items"
      },
      "1774615663456-items": {
        "quantity": 1,
        "title": "Item Earned: Miniature Legionary Helmet",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
        "id": "1772230537870-86781-LNymX-item",
        "type": "items"
      }
    },
    "display": "prizepack",
    "rewardIds": [
      "1772230537866-86781-LNymX-item",
      "1772230537866-86781-LNymX-item",
      "1772230537870-86781-LNymX-item"
    ],
    "type": "rewards",
    "path": "eo08q9fvndpwe3ft7o"
  },
  "1774623170290-JSx4p6pOdtEAGMvzmX3AcbwT-purchase": {
    "info": "",
    "ts": 1774623170290,
    "icon": "/images/icons/shopping-cart.png",
    "cartQuantity": 2,
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Purchase Completed",
    "id": "1774623170290-JSx4p6pOdtEAGMvzmX3AcbwT-purchase",
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "data": {
      "1774623170292hmafw-item": {
        "type": "item",
        "quantity": 2,
        "name": "Otium Ludi (Free Time)",
        "purchase": true,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553717485-Inventory%20Item%20(8).png?alt=media&token=c931ffd9-c0a4-4569-b7ca-a34f8fc09913",
        "id": "1772230537871-86781-LNymX-item",
        "itemType": "inventory",
        "cost": 100,
        "saleId": "",
        "title": "Item Purchased: Otium Ludi (Free Time)"
      }
    },
    "rewardIds": [
      "currency",
      "1772230537871-86781-LNymX-item"
    ],
    "display": "purchase",
    "type": "purchase",
    "cartTotal": 200,
    "path": "xnkepd56m2mgea06t5",
    "title": "Purchase Completed",
    "activity": "Purchase Completed",
    "spec": 200,
    "userName": "Theodore Crane"
  },
  "1774623815987-JSx4p6pOdtEAGMvzmX3AcbwT-submittedItem": {
    "activity": "Item Submitted",
    "title": "Otium Ludi (Free Time)",
    "rewardIds": [
      "1772230537871-86781-LNymX-item"
    ],
    "display": "playerActivity",
    "path": "xwzq8bjw2-op9d75a0",
    "type": "actionItem",
    "id": "1774623815987-JSx4p6pOdtEAGMvzmX3AcbwT-submittedItem",
    "event": "Item Submitted",
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772230537871-86781-LNymX-item",
    "appId": "",
    "ts": 1774623815987,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553717485-Inventory%20Item%20(8).png?alt=media&token=c931ffd9-c0a4-4569-b7ca-a34f8fc09913"
  },
  "1774625418695-1772571725728-86781-LNymX-challenge-edited": {
    "event": "Challenge Edited",
    "id": "1774625418695-1772571725728-86781-LNymX-challenge-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774625418695,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571724680-appian.png?alt=media&token=61febc9d-17f3-462d-b605-d38328bd3d5b",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "The Appian Way has been edited.",
    "display": "managerActivity",
    "path": "wjcwybrqtmmnmnmjz9",
    "type": "editedChallenge"
  },
  "1774625435255-1772571789776-86781-LNymX-challenge-edited": {
    "display": "managerActivity",
    "path": "ssa3s3ym9ssankt26a",
    "type": "editedChallenge",
    "activity": "Challenge Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Amphitheater Critique has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774625435255,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571788594-amphitheater.png?alt=media&token=6d415076-c1b0-426a-adc3-380ed60f1b6e",
    "event": "Challenge Edited",
    "id": "1774625435255-1772571789776-86781-LNymX-challenge-edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774625452310-1772571898963-86781-LNymX-challenge-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774625452310-1772571898963-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "info": "",
    "ts": 1774625452310,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571897664-scroll.png?alt=media&token=654bf7ec-4a07-4d74-95af-4519c85f3b38",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Scriptorium Scroll has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "type": "editedChallenge",
    "path": "-_e45kat_k7dfduq8k"
  },
  "1774625473904-1772572068570-86781-LNymX-challenge-edited": {
    "ts": 1774625473904,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572067641-oracle2.png?alt=media&token=0723ea98-34df-4f78-8bd2-00b53f9b61b7",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Edited",
    "id": "1774625473904-1772572068570-86781-LNymX-challenge-edited",
    "display": "managerActivity",
    "path": "5vpprv9nroq8vegrna",
    "type": "editedChallenge",
    "title": "The Oracle's Verse has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1774625489372-1772572118651-86781-LNymX-challenge-edited": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572117328-journey.png?alt=media&token=7cad1335-9e37-484d-ba59-8f8f6bb99a9d",
    "ts": 1774625489372,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774625489372-1772572118651-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "type": "editedChallenge",
    "path": "wzfk3p9ck8is4ej6k4",
    "display": "managerActivity",
    "title": "The Architects Blueprint has been edited.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Challenge Edited"
  },
  "1774625569845-1772572157879-86781-LNymX-challenge-edited": {
    "title": "The Muse's Soundtrack has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "path": "wyhxzpz_siedsyq3g6",
    "type": "editedChallenge",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Edited",
    "id": "1774625569845-1772572157879-86781-LNymX-challenge-edited",
    "info": "",
    "ts": 1774625569845,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572156886-music.png?alt=media&token=e2354199-92c6-4615-923a-92622ba900c3",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774625604496-1772572212961-86781-LNymX-challenge-edited": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572211824-sculptor.png?alt=media&token=e59179d5-0688-409f-8e17-1d918b7df3a6",
    "info": "",
    "ts": 1774625604496,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Edited",
    "id": "1774625604496-1772572212961-86781-LNymX-challenge-edited",
    "type": "editedChallenge",
    "path": "e_-b86ixwu97a_aa2h",
    "display": "managerActivity",
    "title": "The Scribe's Illuminations has been edited.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Challenge Edited"
  },
  "1774625613920-1772572118651-86781-LNymX-challenge-edited": {
    "info": "",
    "ts": 1774625613920,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572117328-journey.png?alt=media&token=7cad1335-9e37-484d-ba59-8f8f6bb99a9d",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774625613920-1772572118651-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "display": "managerActivity",
    "type": "editedChallenge",
    "path": "te4qff0xwpqwxet_bg",
    "title": "The Architect's Blueprint has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1774625730762-1772569770551-86781-LNymX-challenge-edited": {
    "title": "The Forum Oration has been edited.",
    "activity": "Challenge Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "display": "managerActivity",
    "path": "jas4qg_uj_w3btm5ib",
    "type": "editedChallenge",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Edited",
    "id": "1774625730762-1772569770551-86781-LNymX-challenge-edited",
    "ts": 1774625730762,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774625746647-1772569834612-86781-LNymX-challenge-edited": {
    "title": "The Sibylline Prophecy has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Challenge Edited",
    "type": "editedChallenge",
    "path": "nz6wrkfvm8t564ghe8",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774625746647-1772569834612-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "info": "",
    "ts": 1774625746647,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774625766547-1772569886040-86781-LNymX-challenge-edited": {
    "id": "1774625766547-1772569886040-86781-LNymX-challenge-edited",
    "event": "Challenge Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
    "info": "",
    "ts": 1774625766547,
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Challenge Edited",
    "title": "Veni, Vidi, Vici has been edited.",
    "type": "editedChallenge",
    "path": "ibh66d4ei44mrpswmj",
    "display": "managerActivity"
  },
  "1774643897440-7ms5igiTjjh4cLmunxfSTJU9-level": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "ts": 1774643897440,
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "elementId": "1772590648474-86781-LNymX-level",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "event": "Level Earned",
    "id": "1774643897440-7ms5igiTjjh4cLmunxfSTJU9-level",
    "type": "levels",
    "path": "ewq98we-u3ccj8yjzp",
    "data": {
      "17746438974413s6pv-currency": {
        "quantity": 200,
        "title": "$200 Earned",
        "icon": "/images/icons/currency.png",
        "id": "currency",
        "type": "currency"
      }
    },
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "display": "achievement",
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned"
  },
  "1774663161106-ZCYz3Xwi3rCgnv6BMyZPV88E-level": {
    "title": "Tiro (The Recruit)",
    "activity": "Level Earned",
    "type": "levels",
    "path": "6not4cno2483fmf0uc",
    "data": {
      "1774663161107ddphc-currency": {
        "quantity": 200,
        "title": "$200 Earned",
        "icon": "/images/icons/currency.png",
        "id": "currency",
        "type": "currency"
      }
    },
    "display": "achievement",
    "rewardIds": [
      "1772590648474-86781-LNymX-level",
      "currency"
    ],
    "elementId": "1772590648474-86781-LNymX-level",
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "id": "1774663161106-ZCYz3Xwi3rCgnv6BMyZPV88E-level",
    "event": "Level Earned",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "ts": 1774663161106,
    "info": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom."
  },
  "1774663185404-ZCYz3Xwi3rCgnv6BMyZPV88E-purchase": {
    "type": "purchase",
    "cartTotal": 200,
    "path": "a-hci3pg4_a5p64yqx",
    "data": {
      "1774663185406i6n8z-item": {
        "title": "Item Purchased: The Praetorian Pardon",
        "saleId": "",
        "cost": 200,
        "itemType": "inventory",
        "id": "1772230537885-86781-LNymX-item",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307966654-Inventory%20Item%20(5).png?alt=media&token=8b912143-3194-4e0d-a647-9a7e34c2949d",
        "purchase": true,
        "name": "The Praetorian Pardon",
        "quantity": 1,
        "type": "item"
      }
    },
    "display": "purchase",
    "rewardIds": [
      "currency",
      "1772230537885-86781-LNymX-item"
    ],
    "spec": 200,
    "userName": "Beatrice Knight",
    "activity": "Purchase Completed",
    "title": "Purchase Completed",
    "cartQuantity": 1,
    "icon": "/images/icons/shopping-cart.png",
    "info": "",
    "ts": 1774663185404,
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "id": "1774663185404-ZCYz3Xwi3rCgnv6BMyZPV88E-purchase",
    "event": "Purchase Completed",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774663210139-ZCYz3Xwi3rCgnv6BMyZPV88E-secretCode": {
    "display": "reward",
    "rewardIds": [
      "1772595348386-86781-LNymX-secretCode",
      "currency",
      "1772590997526-86781-LNymX-prizepack"
    ],
    "data": {
      "1774663210140w29fp-currency": {
        "quantity": 50,
        "icon": "/images/icons/currency.png",
        "title": "$50 Earned",
        "id": "currency",
        "type": "currency"
      },
      "177466321014125rps-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "cost": 500,
        "type": "prizepack",
        "quantity": 1,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "title": "Prize Pack Earned: The Tribute Chest"
      }
    },
    "path": "yvhun6hpzn4z5xr9x_",
    "type": "secretCode",
    "activity": "Secret Code Found",
    "comments": "",
    "title": "EPICUS-284",
    "ts": 1774663210139,
    "info": "Hidden in the guidance office",
    "icon": "/images/icons/secret.png",
    "event": "Secret Code Found",
    "id": "1774663210139-ZCYz3Xwi3rCgnv6BMyZPV88E-secretCode",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772595348386-86781-LNymX-secretCode"
  },
  "1774663210142-ZCYz3Xwi3rCgnv6BMyZPV88E-prizepack": {
    "activity": "New Prize Pack",
    "spec": "",
    "title": "The Tribute Chest",
    "display": "prizepack",
    "rewardIds": [
      "1772230537868-86781-LNymX-item",
      "1772230537866-86781-LNymX-item",
      "1772230537875-86781-LNymX-item"
    ],
    "data": {
      "1774663210145-items": {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b",
        "title": "Item Earned: Scroll Fragment",
        "quantity": 1,
        "type": "items",
        "id": "1772230537875-86781-LNymX-item"
      },
      "1774663210144-items": {
        "id": "1772230537866-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "title": "Item Earned: Aureus Coin",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c"
      },
      "1774663210143-items": {
        "id": "1772230537868-86781-LNymX-item",
        "type": "items",
        "quantity": 1,
        "title": "Item Earned: Fragment of a Roman Mosaic Tile",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad"
      }
    },
    "type": "rewards",
    "path": "2057qnr5et3ge38fv3",
    "id": "1774663210142-ZCYz3Xwi3rCgnv6BMyZPV88E-prizepack",
    "event": "Prize Pack Earned",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772590997526-86781-LNymX-prizepack",
    "info": "",
    "ts": 1774663210142,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8"
  },
  "1774792117506-1772230537880-86781-LNymX-item-edited": {
    "ts": 1774792117506,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306786854-Access%20Item%20(2).png?alt=media&token=d6bcc89e-6c1d-4a69-b47b-d57202dd2d1b",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792117506-1772230537880-86781-LNymX-item-edited",
    "display": "managerActivity",
    "path": "4gufihjzf-beokqwsz",
    "type": "editedItem",
    "title": "The Codex Aureus has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": ""
  },
  "1774792166837-1772230537887-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "The Signet Ring (Seal of Authority) has been edited.",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "0qcew0zs5a99x6gi0n",
    "event": "Item Edited",
    "id": "1774792166837-1772230537887-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1774792166837,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306152881-Access%20Item%20(1).png?alt=media&token=9572a5ae-5f50-4478-9e76-0e5f361ddeea"
  },
  "1774792591338-1772230537866-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "type": "editedItem",
    "path": "4dpt0v53fhmgsr9-ho",
    "title": "Aureus Coin has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "ts": 1774792591338,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792591338-1772230537866-86781-LNymX-item-edited"
  },
  "1774792601716-1772230537868-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792601716-1772230537868-86781-LNymX-item-edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad",
    "ts": 1774792601716,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Fragment of a Roman Mosaic Tile has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "type": "editedItem",
    "path": "pse8z4ze48i7h0i6ck",
    "display": "managerActivity"
  },
  "1774792626478-1772230537888-86781-LNymX-item-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "info": "",
    "ts": 1774792626478,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
    "id": "1774792626478-1772230537888-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "pkf85-8_7uxijziuw5",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Jupiter's Thunderbolt has been edited."
  },
  "1774792645379-1772230537891-86781-LNymX-item-edited": {
    "type": "editedItem",
    "path": "hbpj5-mgo6u8daajd8",
    "display": "managerActivity",
    "title": "Mercury's Winged Sandal has been edited.",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295414866-final-sandal.png?alt=media&token=72853a72-1622-45c1-aae9-f5d9dea654dc",
    "info": "",
    "ts": 1774792645379,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774792645379-1772230537891-86781-LNymX-item-edited",
    "event": "Item Edited"
  },
  "1774792657892-1772230537890-86781-LNymX-item-edited": {
    "ts": 1774792657892,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295099861-Inventory%20Item.png?alt=media&token=0d29ad82-fe6e-4e33-88ee-f8cf6a872b48",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792657892-1772230537890-86781-LNymX-item-edited",
    "display": "managerActivity",
    "path": "xp-b2mi-pqojuptt63",
    "type": "editedItem",
    "title": "Minerva's Owl has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774792681494-1772230537889-86781-LNymX-item-edited": {
    "event": "Item Edited",
    "id": "1774792681494-1772230537889-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295527734-Inventory%20Item.png?alt=media&token=84f0a9dc-39d9-492c-9bdf-4309442405ad",
    "info": "",
    "ts": 1774792681494,
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "title": "Neptune's Trident has been edited.",
    "path": "dfdyy8jsy5tvzfx20o",
    "type": "editedItem",
    "display": "managerActivity"
  },
  "1774792694642-1772230537875-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "2z8ukkunddiwran49c",
    "type": "editedItem",
    "title": "Scroll Fragment has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "info": "",
    "ts": 1774792694642,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792694642-1772230537875-86781-LNymX-item-edited"
  },
  "1774792744773-1772230537870-86781-LNymX-item-edited": {
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792744773-1772230537870-86781-LNymX-item-edited",
    "info": "",
    "ts": 1774792744773,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "title": "Miniature Legionary Helmet has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "fjy75ndr0od4m4stcp"
  },
  "1774792969473-1772230537881-86781-LNymX-item-edited": {
    "title": "The Aegis of Aeneas has been edited.",
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "path": "99ghmhx6mbgcry9c47",
    "type": "editedItem",
    "display": "managerActivity",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774792969473-1772230537881-86781-LNymX-item-edited",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303141509-Inventory%20Item%20(2).png?alt=media&token=4f138801-ddcf-4f5e-bd16-824a301c8b03",
    "ts": 1774792969473,
    "info": "",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774792978326-1772230537883-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "vyhtwwa044vf_b0pmf",
    "type": "editedItem",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Apollo’s Laurel has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774792978326,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772300758021-Inventory%20Item%20(1).png?alt=media&token=5c8323e0-6e0c-4333-9aa5-05066cd46138",
    "event": "Item Edited",
    "id": "1774792978326-1772230537883-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774792993109-1772230537882-86781-LNymX-item-edited": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774792993109,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303244750-Inventory%20Item%20(3).png?alt=media&token=8755aa8b-307b-4316-b462-ce838cacdaf5",
    "event": "Item Edited",
    "id": "1774792993109-1772230537882-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "display": "managerActivity",
    "path": "_jej6deee9ihicmpw_",
    "type": "editedItem",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "The Janus Key has been edited."
  },
  "1774793017047-1772230537884-86781-LNymX-item-edited": {
    "ts": 1774793017047,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307861026-Inventory%20Item%20(4).png?alt=media&token=990024c3-53a3-4d76-8eb0-12456828de8e",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774793017047-1772230537884-86781-LNymX-item-edited",
    "event": "Item Edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "n9-mcijxgq8d4-agwr",
    "title": "The Lyre of Orpheus has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774793031022-1772230537885-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "fp8pck5g0h9j69-o96",
    "type": "editedItem",
    "title": "The Praetorian Pardon has been edited.",
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "info": "",
    "ts": 1774793031022,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307966654-Inventory%20Item%20(5).png?alt=media&token=8b912143-3194-4e0d-a647-9a7e34c2949d",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793031022-1772230537885-86781-LNymX-item-edited"
  },
  "1774793041224-1772230537886-86781-LNymX-item-edited": {
    "info": "",
    "ts": 1774793041224,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772308091269-Inventory%20Item%20(6).png?alt=media&token=446851bc-81a0-4b02-9e75-d0fa1c7593ff",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793041224-1772230537886-86781-LNymX-item-edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "u-6s8t0tx3equsmjer",
    "title": "The Standard of the First Legion has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774793209337-1772230537869-86781-LNymX-item-edited": {
    "title": "Magister's Legatus (Teacher's Helper for a Day) has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "q2fta7kg0qe0myicx8",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793209337-1772230537869-86781-LNymX-item-edited",
    "ts": 1774793209337,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553695485-Inventory%20Item%20(7).png?alt=media&token=720d5f6e-2ad6-4c50-82b8-de7fe34d7874",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1774793230918-1772230537871-86781-LNymX-item-edited": {
    "info": "",
    "ts": 1774793230918,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553717485-Inventory%20Item%20(8).png?alt=media&token=c931ffd9-c0a4-4569-b7ca-a34f8fc09913",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Edited",
    "id": "1774793230918-1772230537871-86781-LNymX-item-edited",
    "display": "managerActivity",
    "type": "editedItem",
    "path": "3qathv59mdkrzpyhco",
    "title": "Otium Ludi (Free Time) has been edited.",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably"
  },
  "1774793258707-1772230537874-86781-LNymX-item-edited": {
    "event": "Item Edited",
    "id": "1774793258707-1772230537874-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554064109-Inventory%20Item%20(9).png?alt=media&token=24dc2242-4a6e-4408-92ab-e30dc774b072",
    "ts": 1774793258707,
    "info": "",
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "Pilleus Libertatis (Hat Pass for a Day) has been edited.",
    "path": "ks-eav6-q2qv2aan2_",
    "type": "editedItem",
    "display": "managerActivity"
  },
  "1774793318209-1772230537879-86781-LNymX-item-edited": {
    "id": "1774793318209-1772230537879-86781-LNymX-item-edited",
    "event": "Item Edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564972120-Inventory%20Item%20(13).png?alt=media&token=d82cc334-3bc9-49a7-a89d-13608f1b7dba",
    "info": "",
    "ts": 1774793318209,
    "spec": "",
    "userName": "Adam @ Gamably",
    "activity": "Item Edited",
    "title": "Abacus of the Architect has been edited.",
    "type": "editedItem",
    "path": "ejoipp6fpp6wymnn5f",
    "display": "managerActivity"
  },
  "1774793333472-1772230537876-86781-LNymX-item-edited": {
    "activity": "Item Edited",
    "userName": "Adam @ Gamably",
    "spec": "",
    "title": "Sella Curulis (Special Chair for a Day) has been edited.",
    "display": "managerActivity",
    "path": "-ptkyfw9xyzkikodrj",
    "type": "editedItem",
    "event": "Item Edited",
    "id": "1774793333472-1772230537876-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774793333472,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554085909-Inventory%20Item%20(10).png?alt=media&token=4a453739-b714-480d-985a-84794eab7cdd"
  },
  "1774793344156-1772230537877-86781-LNymX-item-edited": {
    "userName": "Adam @ Gamably",
    "spec": "",
    "activity": "Item Edited",
    "title": "Tabula Rasa (Homework Pass) has been edited.",
    "path": "qdfp744yjp7myk90sc",
    "type": "editedItem",
    "display": "managerActivity",
    "event": "Item Edited",
    "id": "1774793344156-1772230537877-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554116045-Inventory%20Item%20(11).png?alt=media&token=ba00b05b-5742-4579-84d0-25894c91a127",
    "ts": 1774793344156,
    "info": ""
  },
  "1774793356580-1772230537878-86781-LNymX-item-edited": {
    "display": "managerActivity",
    "path": "vzwru8ob0ajb5eny5w",
    "type": "editedItem",
    "activity": "Item Edited",
    "spec": "",
    "userName": "Adam @ Gamably",
    "title": "Tempus Solutum (Free Time) has been edited.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1774793356580,
    "info": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564941724-Inventory%20Item%20(12).png?alt=media&token=19096192-f911-49e3-8280-c8c0e400e266",
    "event": "Item Edited",
    "id": "1774793356580-1772230537878-86781-LNymX-item-edited",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1774818340234-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge": {
    "appId": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
    "ts": 1774818340234,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "id": "1774818340234-OKBBAo2RM44OS9DjaPrHxwrU-submittedChallenge",
    "event": "Challenge Submitted",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569886040-86781-LNymX-challenge",
    "path": "jcgeqtbs4q2xauacyr",
    "type": "actionItem",
    "rewardIds": [
      "1772569886040-86781-LNymX-challenge"
    ],
    "display": "playerActivity",
    "activity": "Challenge Submitted",
    "title": "Veni, Vidi, Vici"
  }
}